interface Locale {
  [key: string]: {
    en_US: string;
    ar_SA: string;
    tr_TR: string;
    pt_BR: string;
    id_ID: string;
    ru_RU: string;
    uz_UZ: string; // 乌兹别克语
    fa_IR: string; // 波斯语
    ur_PK: string;
    zh_CN?: string;
  };
}

const locales: Locale = {
  语言: {
    en_US: 'English',
    ar_SA: 'لغة',
    tr_TR: 'dil',
    pt_BR: 'Idioma',
    id_ID: 'Bahasa',
    ru_RU: 'Язык',
    uz_UZ: 'Til',
    fa_IR: 'زبان',
    ur_PK: 'زبان',
  },
  '请求地址异常，请检查': {
    en_US: 'The request address is abnormal, please check',
    ar_SA: 'عنوان الطلب غير طبيعي، يرجى التحقق',
    tr_TR: 'İstek adresi anormal, lütfen kontrol edin',
    pt_BR: 'O endereço da solicitação é anormal, por favor, verifique',
    id_ID: 'Alamat permintaan tidak normal, silakan periksa',
    ru_RU: 'Адрес запроса некорректен, пожалуйста, проверьте',
    uz_UZ: 'So‘rov manzili g‘ayritabiiy, tekshiring',
    fa_IR: 'آدرس درخواست غیر عادی است، لطفاً بررسی کنید',
    ur_PK: 'درخواست آدرس نامعتبر است، لطفاً تائید کنید',
  },
  '请求网络异常，请稍后': {
    en_US: 'Request network exception, please wait.',
    ar_SA: 'طلب استثناء الشبكة، يرجى الانتظار.',
    tr_TR: 'Ağ istisnası isteyin, lütfen bekleyin.',
    pt_BR: 'Exceção de rede na solicitação, por favor, aguarde.',
    id_ID: 'Jaringan permintaan bermasalah, silakan tunggu.',
    ru_RU: 'Исключение сети запроса, пожалуйста, подождите.',
    uz_UZ: 'So‘rov tarmog‘ida xatolik, iltimos, kuting.',
    fa_IR: 'استثناء شبکه درخواست، لطفاً صبر کنید.',
    ur_PK: 'درخواست اینترنتی خطا دارد، لطفاً منتظر بمانید.',
  },
  请求失败: {
    en_US: 'Request failed',
    ar_SA: 'فشل الطلب',
    tr_TR: 'İstek başarısız oldu',
    pt_BR: 'Solicitação falhou',
    id_ID: 'Permintaan gagal',
    ru_RU: 'Запрос не удался',
    uz_UZ: 'So‘rov muvaffaqiyatsiz bo‘ldi',
    fa_IR: 'درخواست ناموفق بود',
    ur_PK: 'درخواست ناچیز'
  },
  公会: {
    en_US: 'Agency',
    ar_SA: 'يتبع CY',
    tr_TR: 'Acente',
    pt_BR: 'Agência',
    id_ID: 'Agen',
    ru_RU: 'Гильдия',
    uz_UZ: 'Guild',
    fa_IR: 'انجمن',
    ur_PK: 'انجمن'
  },
  搜索: {
    en_US: 'Search',
    ar_SA: 'يبحث',
    tr_TR: 'Ara',
    pt_BR: 'Pesquisar',
    id_ID: 'Cari',
    ru_RU: 'Поиск',
    uz_UZ: 'Qidirish',
    fa_IR: 'جستجو',
    ur_PK: 'تلاش'
  },
  '搜索公会名称/公会长昵称/ID': {
    en_US: 'Search for agency name/Agent nickname/ID',
    ar_SA: 'ابحث عن اسم الوكالة/اسم الوكيل/ ID للوكالة',
    tr_TR: 'Ajans adını/takma adını/kimliğini arayın',
    pt_BR: 'Pesquise por nome da agência/nickname do agente/ID',
    id_ID: 'Cari nama agen/nama panggilan pemilik/ID',
    ru_RU: 'Поиск по имени гильдии/никнейму лидера гильдии/ID',
    uz_UZ: 'Guild nomi / Guild rahbari nikni / ID bo‘yicha qidirish',
    fa_IR: 'جستجو بر اساس نام انجمن/نام مستعار سرپرست انجمن/شناسه',
    ur_PK: 'جستجو براساس نام انجمن/نام یوزرینیک انجمن/شناسه'
  },
  '搜索姓名/ID': {
    en_US: 'Search for name / ID',
    ar_SA: 'يبحث عن الاسم / الهوية',
    tr_TR: 'Isim / Kimlik aramak',
    pt_BR: 'Pesquise por nome / ID',
    id_ID: 'Cari nama / ID',
    ru_RU: 'Поиск по имени / ID',
    uz_UZ: 'Ism / ID bo‘yicha qidirish',
    fa_IR: 'جستجو بر اساس نام/شناسه',
    ur_PK: 'جستجو براساس نام / شناسه'
  },
  加入: {
    en_US: 'Join',
    ar_SA: 'إنضمام',
    tr_TR: 'Katılmak',
    pt_BR: 'Junte-se',
    id_ID: 'Bergabung',
    ru_RU: 'Присоединиться',
    uz_UZ: 'Qo‘shilish',
    fa_IR: 'عضویت',
    ur_PK: 'پیوستن'
  },
  提示: {
    en_US: 'Tips',
    ar_SA: 'إشعار',
    tr_TR: 'İPUÇLARI',
    pt_BR: 'Dicas',
    id_ID: 'Petunjuk',
    ru_RU: 'Подсказки',
    uz_UZ: 'Maslahatlar',
    fa_IR: 'راهنماها',
    ur_PK: 'نکات'
  },
  '确定加入该公会嘛？': {
    en_US: 'Confirm to apply to join this agency?',
    ar_SA: 'هل أنت متؤكد من الانضمام إلى الوكالة هذه؟',
    tr_TR: 'Bu ajansa katılmak için başvuruyu onaylıyor musunuz?',
    pt_BR: 'Confirmar solicitação para se juntar a esta agência?',
    id_ID: 'Konfirmasi permohonan untuk bergabung dengan agen ini?',
    ru_RU: 'Подтвердить заявку на вступление в эту гильдию?',
    uz_UZ: 'Ushbu guildga qo‘shilish so‘rovini tasdiqlaysizmi?',
    fa_IR: 'آیا می‌خواهید درخواست عضویت در این انجمن را تایید کنید؟',
    ur_PK: 'هل می توانید درخواست کنید تا به این انجمن معرفی شوید؟'
  },
  成员申请: {
    en_US: 'Member Application',
    ar_SA: 'طلبات الأعضاء',
    tr_TR: 'Üye Başvurusu',
    pt_BR: 'Aplicação de Membro',
    id_ID: 'Permohonan Anggota',
    ru_RU: 'Заявка на членство',
    uz_UZ: "A'zo arizasi",
    fa_IR: 'درخواست عضویت',
    ur_PK: 'درخواست کاربران'
  },
  已同意: {
    en_US: 'Agreed',
    ar_SA: 'موافق',
    tr_TR: 'Onaylandı',
    pt_BR: 'Acordado',
    id_ID: 'Disetujui',
    ru_RU: 'Согласовано',
    uz_UZ: 'Qabul qilindi',
    fa_IR: 'تایید شده',
    ur_PK: 'اتفاق کیا۔'
  },
  已拒绝: {
    en_US: 'Rejected',
    ar_SA: 'مرفوض',
    tr_TR: 'Reddedildi',
    pt_BR: 'Rejeitado',
    id_ID: 'Ditolak',
    ru_RU: 'Отклонено',
    uz_UZ: 'Rad etildi',
    fa_IR: 'رد شده',
    ur_PK: 'مسترد'
  },
  拒绝: {
    en_US: 'Refuse',
    ar_SA: 'يرفض',
    tr_TR: 'Reddet',
    pt_BR: 'Recusar',
    id_ID: 'Tolak',
    ru_RU: 'Отклонить',
    uz_UZ: 'Rad etish',
    fa_IR: 'رد کردن',
    ur_PK: 'انکار'
  },
  同意: {
    en_US: 'Agree',
    ar_SA: 'موافقة',
    tr_TR: 'Onayla',
    pt_BR: 'Aceitar',
    id_ID: 'Setuju',
    ru_RU: 'Согласиться',
    uz_UZ: 'Rozilik bildirish',
    fa_IR: 'تایید کردن',
    ur_PK: 'متفق '
  },
  会员: {
    en_US: 'Member',
    ar_SA: 'عضو',
    tr_TR: 'Üye',
    pt_BR: 'Membro',
    id_ID: 'Anggota',
    ru_RU: 'Член',
    uz_UZ: "A'zo",
    fa_IR: 'عضو',
    ur_PK: 'ممبر'
  },
  '邀请': {
    en_US: 'Invite',
    ar_SA: 'مشاركة',
    tr_TR: 'Ilaç',
    pt_BR: 'Convidar',
    id_ID: 'Undang',
    ru_RU: 'Пригласить',
    uz_UZ: 'Taklif qilish',
    fa_IR: 'دعوت',
    ur_PK: 'دعوت دیں'
  },
  '移除公会管理员': {
    en_US: 'Remove agency admin',
    ar_SA: 'إزالة مشرف الوكالة',
    tr_TR: 'Ajans yöneticisini kaldır',
    pt_BR: 'Remover administrador da agência',
    id_ID: 'Hapus admin agen',
    ru_RU: 'Удалить администратора гильдии',
    uz_UZ: 'Guild administratorini olib tashlash',
    fa_IR: 'حذف مدیر انجمن',
    ur_PK: 'ایجنسی ایڈمن کو ہٹائیں'
  },
  '设置公会管理员': {
    en_US: 'Set up agency admin',
    ar_SA: 'تعيين مشرف الوكالة',
    tr_TR: 'Ajans yöneticisini ayarla',
    pt_BR: 'Configurar administrador da agência',
    id_ID: 'Atur admin agen',
    ru_RU: 'Назначить администратора гильдии',
    uz_UZ: 'Guild administratorini tayinlash',
    fa_IR: 'تعيين مدیر انجمن',
    ur_PK: 'ایجنسی ایڈمن مقرر کریں'
  },
  '移出公会': {
    en_US: 'Remove from the agency',
    ar_SA: 'إزالته من الوكالة',
    tr_TR: 'Ajanstan kaldır',
    pt_BR: 'Remover da agência',
    id_ID: 'Hapus dari agen',
    ru_RU: 'Удалить из гильдии',
    uz_UZ: 'Guilddan olib tashlash',
    fa_IR: 'حذف از انجمن',
    ur_PK: 'ایجنسی سے نکالیں'
  },
  '没有更多了': {
    en_US: 'No more',
    ar_SA: 'لا يوجد المزيد',
    tr_TR: 'Daha fazla yok',
    pt_BR: 'Não há mais',
    id_ID: 'Tidak ada lagi',
    ru_RU: 'Больше нет',
    uz_UZ: 'Boshqa narsa yo‘q',
    fa_IR: 'دیگر چیزی وجود ندارد',
    ur_PK: 'مزید کچھ نہیں'
  },
  '申请加入失败，请稍后重试~': {
    en_US: 'Application to join failed, please try again later',
    ar_SA: 'فشل تقديم الطلب للانضمام، يرجى المحاولة مرة أخرى في وقت لاحق',
    tr_TR: 'Katılmak için başvuru yapılamadı, lütfen daha sonra tekrar deneyin',
    pt_BR: 'A solicitação para se juntar falhou, por favor, tente novamente mais tarde',
    id_ID: 'Permohonan bergabung gagal, silakan coba lagi nanti',
    ru_RU: 'Заявка на вступление не удалась, попробуйте позже',
    uz_UZ: 'Qo‘shilish so‘rovi muvaffaqiyatsiz bo‘ldi, iltimos, keyinroq qayta urinib ko‘ring',
    fa_IR: 'درخواست عضویت ناموفق بود، لطفاً بعداً دوباره تلاش کنید',
    ur_PK: 'شمولیت کی درخواست ناکام، براہ کرم بعد میں دوبارہ کوشش کریں'
  },
  '申请加入成功，请耐心等待公会通过~': {
    en_US: 'The application to join is successful. Please wait patiently for the guild to approve it.',
    ar_SA: 'تم قبول طلب الانضمام بنجاح، يرجى الانتظار بصبر حتى تتم الموافقة على النقابة.',
    tr_TR: 'Katılım başvurunuz başarılı oldu, lütfen loncanın onaylanmasını sabırla bekleyin.',
    pt_BR: 'A solicitação para se juntar foi bem-sucedida. Aguarde pacientemente até que o gilde a aprova.',
    id_ID: 'Permohonan bergabung berhasil, silakan tunggu hingga agen menyetujui.',
    ru_RU: 'Заявка на вступление принята. Пожалуйста, терпеливо ждите, пока гильдия ее одобрит.',
    uz_UZ: 'Qo‘shilish so‘rovi muvaffaqiyatli yuborildi. Iltimos, guild tasdiqlashini sabr bilan kutib turing.',
    fa_IR: 'درخواست عضویت با موفقیت ارسال شد. لطفاً صبورانه منتظر تایید انجمن باشید.',
    ur_PK: 'شمولیت کی درخواست کامیاب، براہ کرم ایجنسی کی منظوری کا صبر سے انتظار کریں'
  },
  '同意申请失败，请稍后重试~': {
    en_US: 'Agree to apply failed, please try again later',
    ar_SA: 'فشل الموافقة على الطلب للانضمام، يرجى المحاولة مرة أخرى في وقت لاحق',
    tr_TR: 'İlgiye cevaplanmadı, lütfen daha sonra tekrar deneyin',
    pt_BR: 'Falha ao aceitar a aplicação, por favor, tente novamente mais tarde',
    id_ID: 'Gagal menyetujui permohonan, silakan coba lagi nanti',
    ru_RU: 'Не удалось одобрить заявку, попробуйте позже',
    uz_UZ: 'Arizani tasdiqlashda muvaffaqiyatsizlikka uchradik, iltimos, keyinroq qayta urinib ko‘ring',
    fa_IR: 'تایید درخواست ناموفق بود، لطفاً بعداً دوباره تلاش کنید',
    ur_PK: 'درخواست کی منظوری ناکام، براہ کرم بعد میں دوبارہ کوشش کریں'
  },
  '同意成功': {
    en_US: 'Agree successfully',
    ar_SA: 'تم الموافقة بنجاح',
    tr_TR: 'İlgili',
    pt_BR: 'Aceito com sucesso',
    id_ID: 'Disetujui berhasil',
    ru_RU: 'Успешно согласовано',
    uz_UZ: 'Muvaffaqiyatli tasdiqlandi',
    fa_IR: 'تایید با موفقیت انجام شد',
    ur_PK: 'کامیابی سے منظور'
  },
  '拒绝成功': {
    en_US: 'Reject successfully',
    ar_SA: 'تم الرفض بنجاح',
    tr_TR: 'Reddedildi',
    pt_BR: 'Rejeitado com sucesso',
    id_ID: 'Ditolak berhasil',
    ru_RU: 'Успешно отклонено',
    uz_UZ: 'Muvaffaqiyatli rad etildi',
    fa_IR: 'رد با موفقیت انجام شد',
    ur_PK: 'کامیابی سے مسترد'
  },
  '确认同意{{name}}': {
    en_US: 'Confirm to agree {{name}}',
    ar_SA: 'هل ترغب في الموافقة على {{name}}',
    tr_TR: 'İlgiyi onaylamak istiyor musunuz',
    pt_BR: 'Confirmar aceitação de {{name}}',
    id_ID: 'Konfirmasi persetujuan {{name}}',
    ru_RU: 'Подтвердить согласие с {{name}}',
    uz_UZ: '{{name}}ga rozilikni tasdiqlaysizmi?',
    fa_IR: 'آیا می‌خواهید {{name}} را تایید کنید؟',
    ur_PK: 'کیا آپ {{name}} سے اتفاق کرنا چاہتے ہیں؟'
  },
  '确认同意{{name}} (ID:{{id}})加入公会吗？': {
    en_US: 'Confirm to agree {{name}} (ID:{{id}}) to join the agency?',
    ar_SA: 'هل ترغب في الموافقة على {{name}} (ID:{{id}}) للانضمام للنقابة؟',
    tr_TR: '{{name}} (ID:{{id}}) katılımını onaylamak istiyor musunuz?',
    pt_BR: 'Confirmar aceitação de {{name}} (ID:{{id}}) para se juntar à agência?',
    id_ID: 'Konfirmasi persetujuan {{name}} (ID:{{id}}) untuk bergabung dengan agen?',
    ru_RU: 'Подтвердить согласие с {{name}} (ID:{{id}}) в гильдии?',
    uz_UZ: '{{name}} (ID:{{id}}) ga qo‘shilishni tasdiqlaysizmi?',
    fa_IR: 'آیا می‌خواهید {{name}} (ID:{{id}}) را تایید کنید؟',
    ur_PK: 'کیا آپ {{name}} (ID:{{id}}) کو ایجنسی میں شامل ہونے کی منظوری دینا چاہتے ہیں؟'
  },
  '确认拒绝{{name}} (ID:{{id}})加入公会吗？': {
    en_US: 'Confirm to reject {{name}} (ID:{{id}}) to join the agency?',
    ar_SA: 'هل ترغب في رفض {{name}} (ID:{{id}}) للانضمام للنقابة؟',
    tr_TR: '{{name}} (ID:{{id}}) katılımını reddetmek istiyor musunuz?',
    pt_BR: 'Confirmar rejeição de {{name}} (ID:{{id}}) para se juntar à agência?',
    id_ID: 'Konfirmasi penolakan {{name}} (ID:{{id}}) untuk bergabung dengan agen?',
    ru_RU: 'Подтвердить отказ с {{name}} (ID:{{id}}) в гильдии?',
    uz_UZ: '{{name}} (ID:{{id}}) ga qo‘shilishni rad etishni tasdiqlaysizmi?',
    fa_IR: 'آیا می‌خواهید {{name}} (ID:{{id}}) را رد کنید؟',
    ur_PK: 'کیا آپ {{name}} (ID:{{id}}) کی ایجنسی میں شمولیت کو مسترد کرنا چاہتے ہیں؟'
  },
  '公会长': {
    en_US: 'Owner',
    ar_SA: 'وكيل',
    tr_TR: 'Ajans Sahibi',
    pt_BR: 'Proprietário',
    id_ID: 'Pemilik',
    ru_RU: 'Владелец',
    uz_UZ: 'Guild bo‘yicha',
    fa_IR: 'صاحب انجمن',
    ur_PK: 'مالک'
  },
  '公会管理员': {
    en_US: 'Admin',
    ar_SA: 'ادمن',
    tr_TR: 'Yönetici',
    pt_BR: 'Administrador',
    id_ID: 'Admin',
    ru_RU: 'Администратор',
    uz_UZ: 'Admin',
    fa_IR: 'مدیر',
    ur_PK: 'منتظم'
  },
  '公会成员': {
    en_US: 'Member',
    ar_SA: 'أعضاء',
    tr_TR: 'Üyeler',
    pt_BR: 'Membros',
    id_ID: 'Anggota',
    ru_RU: 'Участники',
    uz_UZ: 'Aniqlar',
    fa_IR: 'اعضای صنف',
    ur_PK: 'رکن'
  },
  '确认将{{name}} (ID:{{id}})从公会中移除吗？': {
    en_US: 'Confirm to remove {{name}} (ID:{{id}}) from the agency?',
    ar_SA: 'هل ترغب في حذف {{name}} (ID:{{id}}) من النقابة؟',
    tr_TR: '{{name}} (ID:{{id}}) nın katılımını kaldırmak istiyor musunuz?',
    pt_BR: 'Confirmar remoção de {{name}} (ID:{{id}}) da agência?',
    id_ID: 'Konfirmasi penghapusan {{name}} (ID:{{id}}) dari agen?',
    ru_RU: 'Подтвердить удаление {{name}} (ID:{{id}}) из гильдии?',
    uz_UZ: '{{name}} (ID:{{id}}) ga qo‘shilishni o‘chirishni tasdiqlaysizmi?',
    fa_IR: 'آیا می‌خواهید {{name}} (ID:{{id}}) را از انجمن حذف کنید؟',
    ur_PK: 'کیا آپ {{name}} (ID:{{id}}) کو ایجنسی سے ہٹانے کی تصدیق کرتے ہیں؟'
  },
  '移除失败，请稍后重试~': {
    en_US: 'Remove failed, please try again later',
    ar_SA: 'فشل الحذف، يرجى المحاولة مرة أخرى في وقت لاحق',
    tr_TR: 'Kaldırılamadı, lütfen daha sonra tekrar deneyin',
    pt_BR: 'Falha ao remover, por favor, tente novamente mais tarde',
    id_ID: 'Gagal menghapus, silakan coba lagi nanti',
    ru_RU: 'Не удалось удалить, попробуйте позже',
    uz_UZ: 'O‘chirish muvaffaqiyatsizlik qilindi, iltimos, keyinroq qayta urinib ko‘ring',
    fa_IR: 'حذف ناموفق بود، لطفاً بعداً دوباره تلاش کنید',
    ur_PK: 'حذف ناکام، براہ کرم بعد میں دوبارہ کوشش کریں',
  },
  '确认设置{{name}} (ID:{{id}})为管理员吗？': {
    en_US: 'Confirm to set {{name}} (ID:{{id}}) as admin?',
    ar_SA: 'هل تريد تأكيد تعيين {{name}} (ID:{{id}}) كمسؤول؟',
    tr_TR: '{{name}}(ID:{{id}}) adlı kişinin ajans yöneticisi olarak ayarlanması onaylansın mı?',
    pt_BR: 'Confirmar configuração de {{name}} (ID:{{id}}) como administrador?',
    id_ID: 'Konfirmasi pengaturan {{name}} (ID:{{id}}) sebagai admin?',
    ru_RU: 'Подтвердить назначение {{name}} (ID:{{id}}) в роли администратора?',
    uz_UZ: '{{name}} (ID:{{id}}) ga admin rolini tayyorlashni tasdiqlaysizmi?',
    fa_IR: 'آیا می‌خواهید {{name}} (ID:{{id}}) را به عنوان مدیر انجمن تعیین کنید؟',
    ur_PK: 'کیا آپ {{name}} (ID:{{id}}) کو ایڈمن گیا گیا ہے؟',
  },
  '确认从管理员中移除 {{name}}(ID:{{id}}) 吗？': {
    en_US: 'Confirm to remove {{name}} (ID:{{id}}) from the admin?',
    ar_SA: 'متؤكد في إزالة {{name}}(ID:{{id}}) من مشرفين الوكالة؟',
    tr_TR: "{{name}}(ID:{{id}})'nin yöneticiden kaldırılması onaylansın mı?",
    pt_BR: 'Confirmar remoção de {{name}} (ID:{{id}}) do administrador?',
    id_ID: 'Konfirmasi penghapusan {{name}} (ID:{{id}}) dari admin?',
    ru_RU: 'Подтвердить удаление {{name}} (ID:{{id}}) из списка администраторов?',
    uz_UZ: '{{name}} (ID:{{id}}) ga admin rolini o‘chirishni tasdiqlaysizmi?',
    fa_IR: 'آیا می‌خواهید {{name}} (ID:{{id}}) را از مدیران انجمن حذف کنید؟',
    ur_PK: 'کیا آپ {{name}} (ID:{{id}}) کو ایڈمن سے ہٹانے کی تصدیق کرتے ہیں؟',
  },
  设置公会管理员成功: {
    en_US: 'Set up agency admin successfully',
    ar_SA: 'تم تعيين المشرف',
    tr_TR: 'Ajans yöneticisini başarıyla ayarladınız',
    pt_BR: 'Admin da agência configurado com sucesso',
    id_ID: 'Admin agen diatur berhasil',
    ru_RU: 'Назначен администратор гильдии',
    uz_UZ: 'Admin roli tayyorlandi',
    fa_IR: 'مدیر انجمن تعیین شد',
    ur_PK: 'ایجنسی ایڈمن کامیابی سے مقرر کیا گیا'
  },
  移除公会管理员成功: {
    en_US: 'Removed the admin successfully',
    ar_SA: 'تمت إزلة مشرف الوكالة',
    tr_TR: 'Yönetici başarıyla kaldırıld',
    pt_BR: 'Admin da agência removido com sucesso',
    id_ID: 'Admin agen dihapus berhasil',
    ru_RU: 'Удален из списка администраторов',
    uz_UZ: 'Admin roli o‘chirildi',
    fa_IR: 'مدیر انجمن حذف شد',
    ur_PK: 'ایجنسی ایڈمن کامیابی سے ہٹا دیا گیا'
  },
  '设置公会管理员失败，请稍后重试': {
    en_US: 'Failed to set up the agency admin, please try again later.',
    ar_SA: 'فشل التعيين،يرجى تجربة مرة اخرى',
    tr_TR: 'Ajans yöneticisi ayarlanamadı.Lütfen daha sonra tekrar deneyin.',
    pt_BR: 'Falha ao configurar admin da agência, por favor, tente novamente mais tarde.',
    id_ID: 'Gagal mengatur admin agen, silakan coba lagi nanti.',
    ru_RU: 'Не удалось назначить администратора гильдии, попробуйте позже.',
    uz_UZ: 'Admin roli tayyorlash muvaffaqiyatsizlik qilindi, iltimos, keyinroq qayta urinib ko‘ring.',
    fa_IR: 'تعیین مدیر انجمن ناموفق بود، لطفاً بعداً دوباره تلاش کنید.',
    ur_PK: 'ایجنسی ایڈمن کو مقرر کرنے میں ناکام، براہ کرم بعد میں دوبارہ کوشش کریں'
  },
  '移除管理员失败，请稍后重试': {
    en_US: 'Failed to remove agency admin please try again later',
    ar_SA: 'فشلت الإزالة، يرجى تجربة مرة اخرى',
    tr_TR: 'Ajans yöneticisi kaldırılamadı, lütfen daha sonra tekrar deneyin',
    pt_BR: 'Falha ao remover admin da agência, por favor, tente novamente mais tarde',
    id_ID: 'Gagal menghapus admin agen, silakan coba lagi nanti',
    ru_RU: 'Не удалось удалить из списка администраторов, попробуйте позже',
    uz_UZ: 'Admin roli o‘chirish muvaffaqiyatsizlik qilindi, iltimos, keyinroq qayta urinib ko‘ring',
    fa_IR: 'حذف مدیر انجمن ناموفق بود، لطفاً بعداً دوباره تلاش کنید',
    ur_PK: 'ایجنسی ایڈمن کو ہٹانے میں ناکام، براہ کرم بعد میں دوبارہ کوشش کریں'
  },
  成员数量: {
    en_US: 'Members',
    ar_SA: 'عدد الاعضاء',
    tr_TR: 'Kullanıcılar',
    pt_BR: 'Membros',
    id_ID: 'Jumlah Anggota',
    ru_RU: 'Участники',
    uz_UZ: 'Aniqlar',
    fa_IR: 'تعداد اعضاء',
    ur_PK: 'ارکان کی تعداد',
  },
  邀请成员: {
    en_US: 'Invite Member',
    ar_SA: 'دعوة عضو',
    tr_TR: 'Kullanıcı Ekle',
    pt_BR: 'Convidar Membro',
    id_ID: 'Undang Anggota',
    ru_RU: 'Пригласить участника',
    uz_UZ: 'Aniqni qo‘shish',
    fa_IR: 'دعوتنامه اعضاء',
    ur_PK: 'رکن کو مدعو کریں',
  },
  数据中心: {
    en_US: 'Data Center',
    ar_SA: 'مركز البيانات',
    tr_TR: 'Veri Merkezi',
    pt_BR: 'Centro de Dados',
    id_ID: 'Pusat Data',
    ru_RU: 'Центральный Облако',
    uz_UZ: 'Ma\'ruza',
    fa_IR: 'مرکز داده',
    ur_PK: 'ڈیٹا سینٹر',
  },
  会员收到硬币: {
    en_US: 'Member Received Coins',
    ar_SA: 'تم استلام القيمة',
    tr_TR: 'Yayıncı Coins Sıralaması',
    pt_BR: 'Membro Recebeu Moedas',
    id_ID: 'Anggota Menerima Koin',
    ru_RU: 'Участник получил монеты',
    uz_UZ: 'Aniq koinlar qabul qilindi',
    fa_IR: 'کاربر قیمت ها از دست داده',
    ur_PK: 'رکن کو سکے موصول ہوئے'
  },
  公会不存在: {
    en_US: 'Agency not exist',
    ar_SA: 'الجمعية غير موجودة',
    tr_TR: 'Takım mevcut degil',
    pt_BR: 'Agência não existe',
    id_ID: 'Agen tidak ada',
    ru_RU: 'Гильдия не существует',
    uz_UZ: 'Giladi yoq',
    fa_IR: 'انجمن وجود ندارد',
    ur_PK: 'ایجنسی موجود نہیں',
  },
  已邀请: {
    en_US: 'Invited',
    ar_SA: 'تم الدعوة',
    tr_TR: 'Davet edildi',
    pt_BR: 'Convidado',
    id_ID: 'Sudah Diundang',
    ru_RU: 'Приглашен',
    uz_UZ: 'Qabul qilindi',
    fa_IR: 'دعوت شده',
    ur_PK: 'مدعو کیا گیا',
  },
  邀请成功: {
    en_US: 'Invite successfully',
    ar_SA: 'تم الدعوة بنجاح',
    tr_TR: 'Davet edildi',
    pt_BR: 'Convite bem-sucedido',
    id_ID: 'Undangan berhasil',
    ru_RU: 'Приглашение успешно',
    uz_UZ: 'Qabul qilindi',
    fa_IR: 'دعوت با موفقیت انجام شد',
    ur_PK: 'دعوت کامیابی سے بھیجی گئی'
  },
  '邀请失败，请稍后重试': {
    en_US: 'Invite failed, please try again later',
    ar_SA: 'فشل الدعوة، يرجى المحاولة مرة أخرى في وقت لاحق',
    tr_TR: 'Davet edilemedi, lütfen daha sonra tekrar deneyin',
    pt_BR: 'Falha no convite, por favor, tente novamente mais tarde',
    id_ID: 'Gagal mengundang, silakan coba lagi nanti',
    ru_RU: 'Не удалось пригласить, попробуйте позже',
    uz_UZ: 'Qabul qilish muvaffaqiyatsizlik qilindi, iltimos, keyinroq qayta urinib ko‘ring',
    fa_IR: 'دعوت ناموفق بود، لطفاً بعداً دوباره تلاش کنید',
    ur_PK: 'دعوت نامہ بھیجنے میں ناکام، براہ کرم بعد میں دوبارہ کوشش کریں'
  },
  充值账户: {
    "en_US": "Recharge Account",
    "ar_SA": "حساب الشحن",
    "tr_TR": "şarj hesabı",
    "pt_BR": "Conta de Recarga",
    "id_ID": "Akun Isi Ulang",
    "ru_RU": "Пополнить счет",
    "uz_UZ": "Pulni qo‘shish",
    "fa_IR": "شارژ حساب",
    ur_PK: 'ریچارج اکاؤنٹ',
  },
  充值: {
    "en_US": "Recharge",
    "ar_SA": "الشحن",
    "tr_TR": "şarj etmek",
    "pt_BR": "Recarregar",
    "id_ID": "Isi Ulang",
    "ru_RU": "Пополнить",
    "uz_UZ": "Pul",
    "fa_IR": "شارژ",
    ur_PK: 'ریچارج کریں'
  },
  请输入充值的用户ID: {
    "en_US": "Please Enter User ID",
    "ar_SA": "أدخل ايدي",
    "tr_TR": "Lütfen şarj kullanıcı kimliğini girin",
    "pt_BR": "Por favor, insira o ID do usuário",
    "id_ID": "Silakan masukkan ID pengguna",
    "ru_RU": "Пожалуйста, введите ID пользователя",
    "uz_UZ": "Ism-manzilini kiriting",
    "fa_IR": "لطفاً ایدی کاربر را وارد کنید",
    ur_PK: 'براہ کرم صارف کا ID درج کریں'
  },
  该ID不存在: {
    "en_US": "This ID doesn’t exist.",
    "ar_SA": "هذا الايدي ليس موجودا",
    "tr_TR": "Kimlik mevcut değil",
    "pt_BR": "Este ID não existe.",
    "id_ID": "ID ini tidak ada.",
    "ru_RU": "Этот ID не существует.",
    "uz_UZ": "Ushbu ID mavjud emas.",
    "fa_IR": "این ایدی وجود ندارد",
    ur_PK: 'یہ ID موجود نہیں ہے',
  },
  不能为空: {
    "en_US": "Cannot be empty",
    "ar_SA": "لا يمكن أن تكون فارغة",
    "tr_TR": "Boş olamaz",
    "pt_BR": "Não pode ser vazio",
    "id_ID": "Tidak boleh kosong",
    "ru_RU": "Не может быть пустым",
    "uz_UZ": "To‘xtatilmagan",
    "fa_IR": "نمی‌تواند خالی باشد",
    ur_PK: 'خالی نہیں ہو سکتا'
  },
  查询: {
    "en_US": "Verify",
    "ar_SA": "التحقيق",
    "tr_TR": "Sorgula",
    "pt_BR": "Verificar",
    "id_ID": "Verifikasi",
    "ru_RU": "Проверить",
    "uz_UZ": "Tasdiqlash",
    "fa_IR": "تایید",
    ur_PK: 'تصدیق کریں'
  },
  热门: {
    "en_US": "Hot",
    "ar_SA": "شائع",
    "tr_TR": "popüler",
    "pt_BR": "Popular",
    "id_ID": "Populer",
    "ru_RU": "Популярные",
    "uz_UZ": "Popular",
    "fa_IR": "پربازدیده",
    ur_PK: 'مشہور',
  },
  所有: {
    "en_US": "All",
    "ar_SA": "جميع",
    "tr_TR": "Tümü",
    "pt_BR": "Todos",
    "id_ID": "Semua",
    "ru_RU": "Все",
    "uz_UZ": "Hammasi",
    "fa_IR": "همه",
    ur_PK: 'تمام'
  },
  '阅读并同意App的服务条款、退货政策和隐私政策': {
    "en_US": "Read and agree to App's Terms of Service, Return Policy and Privacy Policy",
    "ar_SA": "اقرأ ووافق على شروط الخدمة سياسة الإرجاع وسياسة الخاصة بشاتي الخصوصية",
    "tr_TR": "App'nin Hizmet Şartları, İade Politikası ve Gizlilik Politikasını okuyun ve kabul edin",
    "pt_BR": "Leia e concorde com os Termos de Serviço, Política de Reembolso e Política de Privacidade do App",
    "id_ID": "Baca dan setujui Syarat dan Ketentuan Layanan, Kebijakan Pengembalian, dan Kebijakan Privasi dari App",
    "ru_RU": "Прочитайте и согласитесь с условиями использования App, политикой возврата и политикой конфиденциальности",
    "uz_UZ": "Appdagi xizmat ko‘rsatmalar, qaytarish politika va maxfiylik shartnomasi bilan tasdiqlang",
    "fa_IR": "به منظور استفاده از قوانین سرویس App و قوانین برگشت و حفظ الخصوصیت، باید قوانین را مطالعه و موافقت کنید",
    ur_PK: 'براہ کرم App کی سروس کی شرائط، واپسی کی پالیسی اور رازداری کی پالیسی کو پڑھیں اور اس سے اتفاق کریں',
  },
  更换其他ID: {
    "en_US": "Recharge other ID",
    "ar_SA": "تغيير الايدي",
    "tr_TR": "Başka bir kimliği değiştir",
    "pt_BR": "Recarregar outro ID",
    "id_ID": "Ganti ID lain",
    "ru_RU": "Изменить другой ID",
    "uz_UZ": "Boshqa IDga o‘tkazish",
    "fa_IR": "تغییر ایدی دیگر",
    ur_PK: 'دوسرا ID ریچارج کریں'
  },
  请先选择需要充值的ID: {
    "en_US": "Please select the ID that needs to be recharged first",
    "ar_SA": "الرجاء إدخال معرف المستخدم",
    "tr_TR": "Lütfen önce şarj edilmesi gereken kimliği seçin",
    "pt_BR": "Por favor, selecione o ID que precisa ser recarregado primeiro",
    "id_ID": "Silakan pilih ID yang perlu diisi ulang",
    "ru_RU": "Пожалуйста, выберите ID, который нужно пополнить",
    "uz_UZ": "Ism-manzilini o‘tkazish uchun tanlang",
    "fa_IR": "لطفاً ایدی کاربری را انتخاب کنید که می‌خواهید شارژ کنید",
    ur_PK: 'براہ کرم وہ ID منتخب کریں جسے ریچارج کرنا ضروری ہے'
  },
  帮助: {
    "en_US": "Help",
    "ar_SA": "ساعد",
    "tr_TR": "yardım",
    "pt_BR": "Ajuda",
    "id_ID": "Bantuan",
    "ru_RU": "Помощь",
    "uz_UZ": "Yordam",
    "fa_IR": "راهنما",
    ur_PK: 'مدد',
  },
  请选择国家: {
    "en_US": "Please select a country",
    "ar_SA": "رجاء قم بإختيار دوله",
    "tr_TR": "Lütfen bir ülke seçin",
    "pt_BR": "Por favor, selecione um país",
    "id_ID": "Silakan pilih negara",
    "ru_RU": "Пожалуйста, выберите страну",
    "uz_UZ": "Tilni tanlang",
    "fa_IR": "لطفاً دلیلی را انتخاب کنید",
    ur_PK: 'براہ کرم ملک منتخب کریں',
  },
  请选择支付方式: {
    "en_US": "Please select mode of payment",
    "ar_SA": "الرجاء تحديد طريقة الدفع",
    "tr_TR": "Lütfen ödeme şeklini seçin",
    "pt_BR": "Por favor, selecione o modo de pagamento",
    "id_ID": "Silakan pilih metode pembayaran",
    "ru_RU": "Пожалуйста, выберите способ оплаты",
    "uz_UZ": "To‘lov uslubi tanlang",
    "fa_IR": "لطفاً روش پرداخت را انتخاب کنید",
    ur_PK: 'براہ کرم ادائیگی کا طریقہ منتخب کریں',
  },
  请选择充值金额: {
    "en_US": "Please enter the recharge amount",
    "ar_SA": "الرجاء إدخال مبلغ إعادة الشحن",
    "tr_TR": "Lütfen şarj miktarını seçin",
    "pt_BR": "Por favor, insira o valor da recarga",
    "id_ID": "Silakan masukkan jumlah isi ulang",
    "ru_RU": "Пожалуйста, введите сумму пополнения",
    "uz_UZ": "Pulni qo‘shish miqdorida kiriting",
    "fa_IR": "لطفاً مبلغی که می‌خواهید شارژ کنید را وارد کنید",
    ur_PK: 'براہ کرم ریچارج کی رقم درج کریں'
  },
  请选择同意条款: {
    "en_US": "Please agree to the terms",
    "ar_SA": "الرجاء الموافقة على الشروط",
    "tr_TR": "Lütfen şartları kabul etmeyi seçin",
    "pt_BR": "Por favor, concorde com os termos",
    "id_ID": "Silakan setujui syarat dan ketentuan",
    "ru_RU": "Пожалуйста, подтвердите условия",
    "uz_UZ": "Shartnomani qabul qilishga ruxsat berish",
    "fa_IR": "لطفاً شرایط را موافقت کنید",
    ur_PK: 'براہ کرم شرائط سے اتفاق کریں'
  },
  成功: {
    "en_US": "The operation was successful",
    "ar_SA": "العملية كانت ناجحه",
    "tr_TR": "İşlem Başarılı Oldu",
    "pt_BR": "A operação foi bem-sucedida",
    "id_ID": "Operasi berhasil",
    "ru_RU": "Операция выполнена успешно",
    "uz_UZ": "Operatsiya muvaffaqiyatli amalga oshirildi",
    "fa_IR": "عملیات موفقیت آمیز بود",
    ur_PK: 'عمل کامیابی سے مکمل ہوا'
  },
  登录: {
    en_US: "Log in",
    ar_SA: "تسجيل الدخول",
    tr_TR: "Giriş Yap",
    pt_BR: "Entrar",
    id_ID: "Masuk",
    ru_RU: "Войти",
    uz_UZ: "Kirish",
    fa_IR: "ورود",
    ur_PK: "لاگ ان کریں"
  },
  用户名: {
    en_US: "UserName",
    ar_SA: "اسم المستخدم",
    tr_TR: "Kullanıcı Adı",
    pt_BR: "Nome de Usuário",
    id_ID: "Nama Pengguna",
    ru_RU: "Имя пользователя",
    uz_UZ: "Ism-manzil",
    fa_IR: "نام کاربری",
    ur_PK: "صارف کا نام"
  },
  用户名不能为空: {
    en_US: "User name cannot be empty",
    ar_SA: "اسم المستخدم لا يمكن ان يكون فارغ",
    tr_TR: "Kullanıcı adı bos olamaz",
    pt_BR: "O nome de usuário não pode ser vazio",
    id_ID: "Nama pengguna tidak boleh kosong",
    ru_RU: "Имя пользователя не может быть пустым",
    uz_UZ: "Ism-manzil to‘xtatilmagan",
    fa_IR: "نام کاربری نمی‌تواند خالی باشد",
    ur_PK: "صارف کا نام خالی نہیں ہو سکتا"
  },
  密码: {
    en_US: "Password",
    ar_SA: "كلمة المرور",
    tr_TR: "Parola",
    pt_BR: "Senha",
    id_ID: "Kata Sandi",
    ru_RU: "Пароль",
    uz_UZ: "Parol",
    fa_IR: "رمز عبور",
    ur_PK: "پاس ورڈ"
  },
  密码不能为空: {
    en_US: "Password cannot be empty",
    ar_SA: "كلمة المرور لا يمكن ان تكون فارغة",
    tr_TR: "Parola bos olamaz",
    pt_BR: "A senha não pode ser vazia",
    id_ID: "Kata sandi tidak boleh kosong",
    ru_RU: "Пароль не может быть пустым",
    uz_UZ: "Parol to‘xtatilmagan",
    fa_IR: "رمز عبور نمی‌تواند خالی باشد",
    ur_PK: "پاس ورڈ خالی نہیں ہو سکتا"
  },
  硬币转移: {
    en_US: "Coin Transfer",
    ar_SA: "نقل العملات",
    tr_TR: "Coins Transfer",
    pt_BR: "Transferência de Moedas",
    id_ID: "Pemindahan Koin",
    ru_RU: "Перевод монет",
    uz_UZ: "Pulni o‘tkazish",
    fa_IR: "انتقال اموات",
    ur_PK: "سکوں کی منتقلی"
  },
  可用金币: {
    en_US: "Available coins",
    ar_SA: "العملات المتوفرة",
    tr_TR: "Gönderilebilir Coins",
    pt_BR: "Moedas Disponíveis",
    id_ID: "Koin Tersedia",
    ru_RU: "Доступные монеты",
    uz_UZ: "Mavjud pullar",
    fa_IR: "اموات موجوده",
    ur_PK: "دستیاب سکے"
  },
  分配: {
    en_US: "Distribute",
    ar_SA: "توزيع",
    tr_TR: "Gönder",
    pt_BR: "Distribuir",
    id_ID: "Distribusikan",
    ru_RU: "Распределить",
    uz_UZ: "Bajarish",
    fa_IR: "توزیع",
    ur_PK: "تقسیم کریں"
  },
  输入您要转移的用户ID: {
    en_US: "Input the user ID you want to transfer",
    ar_SA: "أدخل معرف المستخدم الذي تريد نقله",
    tr_TR: "Aktarmak istediğiniz kullanıcı kimliğini girin",
    pt_BR: "Digite o ID do usuário que deseja transferir",
    id_ID: "Masukkan ID pengguna yang ingin Anda transfer",
    ru_RU: "Введите ID пользователя, которого хотите перевести",
    uz_UZ: "Pulni o‘tkazish uchun foydalanuvchi ID ni kiriting",
    fa_IR: "لطفاً ایدی کاربری را که می‌خواهید انتقال کنید را وارد کنید",
    ur_PK: "وہ صارف ID درج کریں جسے آپ منتقل کرنا چاہتے ہیں"
  },
  请输入用户ID: {
    "en_US": "Please input user ID",
    "ar_SA": "الرجاء إدخال معرف المستخدم",
    "tr_TR": "Lütfen kullanıcı kimliğini girin",
    "pt_BR": "Por favor, insira o ID do usuário",
    "id_ID": "Silakan masukkan ID pengguna",
    "ru_RU": "Пожалуйста, введите ID пользователя",
    "uz_UZ": "Ism-manzilini kiriting",
    "fa_IR": "لطفاً ایدی کاربری را وارد کنید",
    ur_PK: 'براہ کرم صارف ID کا ورود کریں'
  },
  请输入您要转账的金额: {
    "en_US": 'Input the amount you want to transfer',
    "ar_SA": 'أدخل المبلغ الذي تريد تحويله',
    "tr_TR": 'Transfer etmek istediğiniz tutarı girin',
    "pt_BR": 'Insira o valor que deseja transferir',
    "id_ID": 'Masukkan jumlah yang ingin Anda transfer',
    "ru_RU": 'Введите сумму перевода',
    "uz_UZ": 'Pulni o‘tkazish uchun miqdori kiriting',
    "fa_IR": 'لطفاً مبلغی که می‌خواهید انتقال کنید را وارد کنید',
    ur_PK: 'براہ کرم منتقل کرنا چاہتے ہیں جسے کیلئے مبلغ ورود کریں',
  },
  '一次最多{{num}}': {
    en_US: 'Max {{num}} in 1 time',
    ar_SA: 'الحد الأقصى {{num}} في المرة الواحدة',
    tr_TR: '1 seferde en fazla {{num}}',
    pt_BR: 'Máximo {{num}} uma vez',
    id_ID: 'Maksimum {{num}} satu kali',
    ru_RU: 'Максимум {{num}} за раз',
    uz_UZ: '1 ta o‘tkazishda {{num}}',
    fa_IR: 'حداکثر {{num}} در یک بار',
    ur_PK: '1 صد کے سے مبلغ نہیں کمتر از {{num}} کیلئے',
  },
  'confirmTransferTxt': {
    zh_CN: '确认转账<b>{{num}}</b>个金币至ID:<b>{{id}}</b>',
    en_US: 'Confirm to transfer <b>{{num}}</b> coins to ID:<b>{{id}}</b>',
    ar_SA: 'تأكيد توزيع <b>{{num}}</b> كونزات إلى المعرف:<b>{{id}}</b>',
    tr_TR: "<b>{{num}}</b> ID'ye Altın Aktarılmasını Onaylayın:<b>{{id}}</b>",
    pt_BR: "Confirmar transferência de <b>{{num}}</b> moedas para o ID:<b>{{id}}</b>",
    id_ID: "Konfirmasi transfer <b>{{num}}</b> koin ke ID:<b>{{id}}</b>",
    ru_RU: "Подтвердите перевод <b>{{num}}</b> монет на ID:<b>{{id}}</b>",
    uz_UZ: "Pulni o‘tkazishni tasdiqlang<b>{{num}}</b> pul o‘tkazish uchun ID:<b>{{id}}</b>",
    fa_IR: "تایید انتقال <b>{{num}}</b> اموات به ID:<b>{{id}}</b>",
    ur_PK: "تصدیق منتقل <b>{{num}}</b> سکوں کے ID:<b>{{id}}</b>"
  },
  '该用户不属于您所在的国家': {
    en_US: 'The user is not from your country',
    ar_SA: 'المستخدم ليس من بلدك',
    tr_TR: 'Kullanıcı sizin ülkenizden değil',
    pt_BR: 'O usuário não é de seu país',
    id_ID: 'Pengguna tersebut tidak berasal dari negara Anda',
    ru_RU: 'Пользователь не является членом вашей страны',
    uz_UZ: 'Foydalanuvchi sizning davlatning asosan emas',
    fa_IR: 'کاربر این کشوری نیست',
    ur_PK: 'صارف ہی کے دنیا نہیں ہے',
  },
  转账成功: {
    en_US: "Transfer successfully",
    ar_SA: "تم التوزيع بنجاح",
    tr_TR: "Başarıyla Aktarıldı",
    pt_BR: "Transferência bem-sucedida",
    id_ID: "Transfer berhasil",
    ru_RU: "Перевод успешно выполнен",
    uz_UZ: "Pulni o‘tkazish muvaffaqiyatli amalga oshirildi",
    fa_IR: "انتقال موفقیت آمیز بود",
    ur_PK: "رقم کی منتقلی کامیاب رہی"
  },
  '亲爱的App用户：': {
    en_US: 'Dear App users:',
    ar_SA: ':عزيزي مستخدمي',
    tr_TR: 'Sevgili App Kullanıcıları:',
    pt_BR: 'Queridos usuários do App:',
    id_ID: 'Hormat kami kepada pengguna App:',
    ru_RU: 'Уважаемые пользователи App:',
    uz_UZ: 'Sizning App foydalanuvchilaringiz:',
    fa_IR: 'به مستخدمان App خوش آمدید:',
    ur_PK: 'بہت آپ کے ساتھ App کاربران:'
  },
  '最近，我们发现有些用户恶意退款，我们无法容忍这种欺诈性的非法金币购买行为。': {
    en_US: 'Recently, we have seen some users maliciously refunding money, and we cannot tolerate such fraudulent and illegal gold purchases.',
    ar_SA: 'لاحظنا مؤخرًا أن بعض المستخدمين قاموا برد الأموال بشكل ضار، لا يمكننا أن نتسامح مع هذا الشراء الاحتيالي وغير القانوني للعملة الذهبية',
    tr_TR: 'Son zamanlarda bazı kullanıcıların kötü niyetli olarak Coins&Yakut iadesi yaptığını görüyoruz ve bu tür hileli ve yasa dışı coins, yakut alımlarına tolerans gösteremeyiz.',
    pt_BR: 'Recentemente, vimos alguns usuários reembolsando dinheiro de forma maliciosa, não podemos tolerar esse tipo de compra fraudulenta e ilegal de moedas de ouro.',
    id_ID: 'Baru-baru ini, kami melihat beberapa pengguna melakukan pengembalian dana dengan sengaja, kami tidak dapat menerima perilaku pembelian koin ilegal dan penipuan seperti ini.',
    ru_RU: 'Недавно мы обнаружили, что некоторые пользователи мошенно возвращают деньги, и мы не можем пренебречь этому фraudulentному и незаконному покупке золота.',
    uz_UZ: 'Biz yaqinda ayrim foydalanuvchilar tomonidan zararli pul qaytarish holatlarini payqadik va bu kabi firibgarlik va noqonuniy tanga sotib olishni qabul qila olmaymiz.',
    fa_IR: 'در دورانی که ما بعضی از کاربران اموات را مشکوک به آگاهی داده‌اند، ما نمی‌توانیم همچنان از این کار استفاده کنیم. بنابراین، ما همچنان به این کار متعهد می‌شویم.',
    ur_PK: 'حال ہی میں، ہم نے کچھ صارفین کو بدنیتی پر مبنی رقوم کی واپسی کرتے دیکھا ہے، اور ہم اس طرح کی دھوکہ دہی اور غیر قانونی سونے کی خریداری کو برداشت نہیں کر سکتے۔'
  },
  txt2: {
    en_US: 'Any ID malicious refunds after recharge will be detected by the system and will be regarded as a malicious fraudulent user, and the system will penalize this ID. Penalties include but are not limited to: recharge restrictions, currency usage restrictions, room entry restrictions, permanent ID bans, permanent bans on devices, etc.',
    ar_SA: 'سيتم الكشف عن أي استرداد ضار بعد إعادة شحن المعرف بواسطة النظام. سيعتبر هذا الأيدي مستخدما احتياليا ضارا، وسيقوم النظام بمعاقبة هذا الأيدي. تشمل العقوبات على سبيل المثال لا الحصر: الحد من إعادة الشحن، والحد من استخدام العملة، والحد من دخول إلى الغرفة، وحظر أيدي أبدا، وحظر الجهاز أبدا، وما إلى ذلك',
    tr_TR: 'Yükleme sonrasında yapılan herhangi bir geri iade sistem tarafından tespit edilecek ve kötü niyetli dolandırıcı bir kullanıcı olarak kabul edilecek ve sistem bu kişiyi veya kişileri cezalandıracaktır. Cezalar şunları içerir ancak bunlarla sınırlı değildir: Yeniden yükleme kısıtlamaları, Coins&Yakut kullanım kısıtlamaları, Odaya giriş kısıtlamaları, Kalıcı ID yasakları, Cihazlara kalıcı yasaklar vb.',
    pt_BR: 'Qualquer reembolso malicioso após a recarga será detectado pelo sistema e será considerado um usuário fraudulento. O sistema penalizará esse ID. As penalidades incluem, mas não se limitam a: restrições de recarga, restrições de uso de moedas, restrições de entrada na sala, banimento permanente do ID, banimento permanente do dispositivo, etc.',
    id_ID: 'Setiap pengembalian dana sengaja setelah melakukan isi ulang akan dideteksi oleh sistem dan dianggap sebagai pengguna penipu. Sistem akan menegakkan hukuman terhadap ID tersebut. Hukuman mencakup, tetapi tidak terbatas pada: batasan isi ulang, batasan penggunaan koin, batasan masuk ruangan, pemblokiran permanen ID, pemblokiran permanen perangkat, dll.',
    ru_RU: 'Любые вредоносные возвраты средств по идентификатору после пополнения счета будут обнаружены системой и будут расценены как злонамеренный мошеннический пользователь, и система наложит штраф на этот идентификатор. Штрафы включают в себя, помимо прочего: ограничения на пополнение счета, ограничения на использование валюты, ограничения на вход в комнату, постоянные запреты на идентификатор, постоянные запреты на использование устройств и т. д.',
    uz_UZ: 'To‘lovdan so‘ng har qanday identifikatorni noto‘g‘ri qaytarish tizim tomonidan aniqlanadi va zararli firibgar foydalanuvchi sifatida ko‘rib chiqiladi va tizim ushbu IDni jazolaydi. Jarimalarga quyidagilar kiradi, lekin ular bilan cheklanmaydi: to‘ldirish cheklovlari, valyutadan foydalanish cheklovlari, xonaga kirish cheklovlari, IDni doimiy ravishda taqiqlash, qurilmalarda doimiy taqiqlar va hokazo.',
    fa_IR: 'هرگونه بازپرداخت مخرب شناسه پس از شارژ مجدد توسط سیستم شناسایی می‌شود و به عنوان یک کاربر کلاهبردار مخرب در نظر گرفته می‌شود و سیستم این شناسه را جریمه می‌کند.',
    ur_PK: 'کوئی بھی ID جو ریچارج کے بعد بدنیتی پر مبنی واپسی کرے گا اسے نظام شناخت کرے گا اور اسے دھوکہ دہی اور جعلی صارف سمجھا جائے گا، اور نظام اس ID کو سزا دے گا۔'
  },
  '请珍惜您的账号，不要将账号交给他人，远离欺诈性购买，共同维护正常秩序，同时，我们也欢迎用户的举报。': {
    en_US: 'Please value your account, do not give your account to others, stay away from fraudulent purchases. At the same time, we also welcome users to report!',
    ar_SA: 'يرجى الاعتزاز بحسابك، وعدم إعطاء حسابك للآخرين، والابتعاد عن عمليات الشراء الاحتيالية، والحفاظ بشكل مشترك على أمر فله ! في الوقت نفسه، نرحب أيضا بالمستخدمين للإبلاغ',
    tr_TR: 'Lütfen hesabınızın kıymetini bilin, hesabınızı başkalarına vermeyin, hileli alışverişlerden uzak durun. Aynı zamanda kullanıcıları da bu tür kullanıcıları tesbit halinde yönetime bilgi vermeye davet eder İyi Eğlenceler Dileriz.',
    pt_BR: 'Por favor, valorize sua conta, não entregue sua conta a outras pessoas, fique longe de compras fraudulentas. Ao mesmo tempo, também damos as boas-vindas aos usuários para denunciar!',
    id_ID: 'Harap hargai akun Anda, jangan berikan akun Anda kepada orang lain, jauhilah pembelian penipuan. Pada saat yang sama, kami juga menyambut pengguna untuk melaporkan!',
    ru_RU: 'Пожалуйста, воспользуйтесь своей учетной записью, не передавайте ее кому-либо, оставайтесь далеко от фишинговых покупок. В то же время, мы рады принять отзывы от пользователей!',
    uz_UZ: 'Sizning hisobingizni qiymatini o‘rganishni maslahat berish, hisobingizni boshqa foydalanuvchilarga yuborishni xohlayman.',
    fa_IR: 'لطفا حساب خود را قيم و داشته باشید، حساب شما را به دیگران ندهید و از فروش های احتمالی دور داشته باشید.',
    ur_PK: 'براہ کرم اپنے اکاؤنٹ کی قدر کریں، اسے دوسروں کو نہ دیں، دھوکہ دہی کی خریداری سے دور رہیں۔'
  },
  '金币转账记录': {
    en_US: 'Coin Transfer Record',
    ar_SA: 'رسوم التحويل الكوين',
    tr_TR: 'Para Transfer Detayları',
    pt_BR: 'Registro de Transferência de Moedas',
    id_ID: 'Catatan Transfer Koin',
    ru_RU: 'Запись перевода монет',
    uz_UZ: 'Koin transfer qaydlari',
    fa_IR: 'رسید تراکنش ارز',
    ur_PK: 'سکوں کی منتقلی کا ریکارڈ'
  },
  支付: {
    en_US: 'Payment',
    ar_SA: 'دفع',
    tr_TR: 'Ödeme',
    pt_BR: 'Pagamento',
    id_ID: 'Pembayaran',
    ru_RU: 'Оплата',
    uz_UZ: 'To‘lov',
    fa_IR: 'پرداخت',
    ur_PK: 'ادائیگی'
  },
  支付成功: {
    en_US: 'Payment successful',
    ar_SA: 'تم الدفع بنجاح',
    tr_TR: 'Ödeme başarılı',
    pt_BR: 'Pagamento bem-sucedido',
    id_ID: 'Pembayaran berhasil',
    ru_RU: 'Оплата прошла успешно',
    uz_UZ: 'To‘lov muvaffaqiyatli',
    fa_IR: 'پرداخت موفق',
    ur_PK: 'ادائیگی کامیاب'
  },
  处理中: {
    en_US: 'Processing',
    ar_SA: 'قيد المعالجة',
    tr_TR: 'İşleniyor',
    pt_BR: 'Processando',
    id_ID: 'Sedang diproses',
    ru_RU: 'Обрабатывается',
    uz_UZ: 'Bajarilmoqda',
    fa_IR: 'در حال انجام',
    ur_PK: 'پروسیسنگ'
  },
  支付失败: {
    en_US: 'Payment failed',
    ar_SA: 'فشل الدفع',
    tr_TR: 'Ödeme başarısız',
    pt_BR: 'Pagamento falhou',
    id_ID: 'Pembayaran gagal',
    ru_RU: 'Оплата не удалась',
    uz_UZ: 'To‘lov muvaffaqiyatsiz',
    fa_IR: 'پرداخت ناموفق',
    ur_PK: 'ادائیگی ناکام'
  },
  订单关闭: {
    en_US: 'Order closed',
    ar_SA: 'تم إغلاق الطلب',
    tr_TR: 'Sipariş kapatıldı',
    pt_BR: 'Pedido fechado',
    id_ID: 'Pesanan ditutup',
    ru_RU: 'Заказ закрыт',
    uz_UZ: 'Buyurtma qutsuq',
    fa_IR: 'سفارش بسته شد',
    ur_PK: 'آرڈر بند'
  },
  支付金额: {
    en_US: 'Payment amount',
    ar_SA: 'مبلغ الدفع',
    tr_TR: 'Ödeme miktarı',
    pt_BR: 'Valor do pagamento',
    id_ID: 'Jumlah pembayaran',
    ru_RU: 'Сумма оплаты',
    uz_UZ: 'To‘lov miqdori',
    fa_IR: 'مبلغ پرداخت',
    ur_PK: 'ادائیگی کی رقم'
  },
  获得金币: {
    en_US: 'Get coins',
    ar_SA: 'الحصول على العملات',
    tr_TR: 'Coins kazan',
    pt_BR: 'Obter moedas',
    id_ID: 'Dapatkan koin',
    ru_RU: 'Получить монеты',
    uz_UZ: 'Koinni olish',
    fa_IR: 'دریافت ارز',
    ur_PK: 'سکے حاصل کریں'
  },
  付款编号: {
    en_US: 'Payment No.',
    ar_SA: 'رقم الدفع',
    tr_TR: 'Ödeme numarası',
    pt_BR: 'Número do pagamento',
    id_ID: 'Nomor pembayaran',
    ru_RU: 'Номер платежа',
    uz_UZ: 'To‘lov raqami',
    fa_IR: 'شماره پرداخت',
    ur_PK: 'ادائیگی نمبر'
  },
  订单编号: {
    en_US: 'Order No.',
    ar_SA: 'رقم الطلب',
    tr_TR: 'Sipariş numarası',
    pt_BR: 'Número do pedido',
    id_ID: 'Nomor pesanan',
    ru_RU: 'Номер заказа',
    uz_UZ: 'Buyurtma raqami',
    fa_IR: 'شماره سفارش',
    ur_PK: 'آرڈر نمبر'
  },
  返回充值: {
    en_US: 'Back to Recharge',
    ar_SA: 'العودة للشحن',
    tr_TR: 'Şarja geri dön',
    pt_BR: 'Voltar para recarga',
    id_ID: 'Kembali ke isi ulang',
    ru_RU: 'Вернуться к пополнению',
    uz_UZ: 'Qayta to‘lov',
    fa_IR: 'بازگشت به شارژ',
    ur_PK: 'ریچارج پر واپس جائیں'
  },
  联系客服: {
    en_US: 'Contact Customer Service',
    ar_SA: 'اتصل بخدمة العملاء',
    tr_TR: 'Müşteri hizmetlerine başvurun',
    pt_BR: 'Contate o atendimento ao cliente',
    id_ID: 'Hubungi layanan pelanggan',
    ru_RU: 'Свяжитесь с службой поддержки',
    uz_UZ: 'Biz bilan aloqa',
    fa_IR: 'تماس با سرویس های پشتیبانی',
    ur_PK: 'کسٹمر سروس سے رابطہ کریں'
  },
  知道了: {
    en_US: 'Got it',
    ar_SA: 'حسنا',
    tr_TR: 'Anladım',
    pt_BR: 'Entendi',
    id_ID: 'Mengerti',
    ru_RU: 'Понял',
    uz_UZ: 'Aniq',
    fa_IR: 'فهمیدم',
    ur_PK: 'سمجھ گیا'
  },
  复制: {
    en_US: 'Copy',
    ar_SA: 'نسخ',
    tr_TR: 'Kopyala',
    pt_BR: 'Copiar',
    id_ID: 'Salin',
    ru_RU: 'Копировать',
    uz_UZ: 'Nusxalash',
    fa_IR: 'کپی',
    ur_PK: 'نقل کریں'
  },
  '您的订单正在处理中，请稍候。': {
    en_US: 'Your order is being processed, please wait a moment.',
    ar_SA: 'طلبك قيد المعالجة، يرجى الانتظار لحظة.',
    tr_TR: 'Siparişiniz işleniyor, lütfen bir dakika bekleyin.',
    pt_BR: 'Seu pedido está sendo processado, por favor, aguarde um momento.',
    id_ID: 'Pesanan Anda sedang diproses, harap tunggu sebentar.',
    ru_RU: 'Ваш заказ обрабатывается, пожалуйста, подождите немного.',
    uz_UZ: 'Sizning buyurtmaniz bajarilmoqda, iltimos kuting.',
    fa_IR: 'سفارش شما در حال انجام است، لطفاً شکیبا باشید.',
    ur_PK: 'آپ کا آرڈر پروسیسنگ میں ہے، براہ کرم انتظار کریں۔'
  },
  上级代理: {
    en_US: 'Superior',
    ar_SA: 'أفضل',
    tr_TR: 'Üstün',
    pt_BR: 'Superior',
    id_ID: 'Atasan',
    ru_RU: 'Первый',
    uz_UZ: 'Yuqori',
    fa_IR: 'بالاتر',
    ur_PK: 'اعلیٰ'
  },
  '该用户为你的代理人，转账成功后，他将获得代理币。': {
    en_US: 'This user is your agent. After the transfer is successful, he will receive agent coins.',
    ar_SA: 'هذا المستخدم هو مسؤولك. بعد تسليم العملية، سيتم استلام كوينات المسؤول.',
    tr_TR: 'Bu kullanıcı sizin aracınız. Transfer başarılı olduktan sonra aracınız kazanılan coins alacaktır.',
    pt_BR: 'Este usuário é seu agente. Após a transferência ser bem-sucedida, ele receberá moedas de agente.',
    id_ID: 'Pengguna ini adalah agen Anda. Setelah transfer berhasil, dia akan menerima koin agen.',
    ru_RU: 'Этот пользователь является вашим агентом. После успешного перевода, он получит коины агента.',
    uz_UZ: 'Bu foydalanuvchi sizning agentingiz. Transfer muvaffaqiyatli bajarilgandan so‘ng, agent koinlarini oladi.',
    fa_IR: 'این کاربر مسؤول شما می باشد. بعد از انجام تراکنش، او ارزهای مسؤولی را دریافت خواهد کرد.',
    ur_PK: 'یہ صارف آپ کا ایجنٹ ہے۔ کامیاب منتقلی کے بعد، وہ ایجنٹ سکے حاصل کرے گا۔'
  },
  'confirmTransferTxt2': {
    zh_CN: '确认转账<b>{{num}}</b><strong>代理金币</strong>至ID:<b>{{id}}</b>',
    en_US: 'Confirm to transfer <b>{{num}}</b> <strong>agent coins</strong> to ID:<b>{{id}}</b>',
    ar_SA: 'تأكيد توزيع <b>{{num}}</b> <strong>كونزات coins</strong> إلى المعرف:<b>{{id}}</b>',
    tr_TR: 'Aktarmak için onaylayın <b>{{num}}</b> <strong> ajans altınları</strong> to ID:<b>{{id}}</b>',
    pt_BR: 'Confirme a transferência de <b>{{num}}</b> <strong>moedas de agente</strong> para o ID:<b>{{id}}</b>',
    id_ID: 'Konfirmasi transfer <b>{{num}}</b> <strong>koin agen</strong> ke ID:<b>{{id}}</b>',
    ru_RU: 'Подтвердите перевод <b>{{num}}</b> <strong>акций агента</strong> на ID:<b>{{id}}</b>',
    uz_UZ: 'To‘lovni tasdiqlash <b>{{num}}</b> <strong>agent koinlari</strong> ID:<b>{{id}}</b>',
    fa_IR: 'تایید تراکنش <b>{{num}}</b> <strong>ارزهای مسؤولی</strong> به شماره ID:<b>{{id}}</b>',
    ur_PK: 'منتقلی کی تصدیق کریں <b>{{num}}</b> <strong>ایجنٹ سکے</strong> ID:<b>{{id}}</b> پر'
  },
  详情: {
    en_US: 'Details',
    ar_SA: 'تفاصيل',
    tr_TR: 'Ayrıntılar',
    pt_BR: 'Detalhes',
    id_ID: 'Rincian',
    ru_RU: 'Подробности',
    uz_UZ: 'Ma\'lumotlar',
    fa_IR: 'جزئیات',
    ur_PK: 'تفصیلات'
  },
  公会数据: {
    en_US: 'Agency Data',
    ar_SA: 'بينات الوكالة',
    tr_TR: 'Klan Verileri',
    id_ID: 'Data Serikat',
    pt_BR: 'Dados da Guilda',
    ru_RU: 'Данные агентства',
    uz_UZ: "Agentlik ma'lumotlari",
    fa_IR: 'اطلاعات گروه',
    ur_PK: 'ایجنسی کا ڈیٹا'
  },
  个人数据: {
    en_US: 'Personal Data',
    tr_TR: 'Kişisel Veriler',
    ar_SA: 'البيانات الشخصية',
    id_ID: 'Data Pribadi',
    pt_BR: 'Dados Pessoais',
    ru_RU: 'Личные данные',
    uz_UZ: "Shaxsiy ma'lumotlar",
    fa_IR: 'اطلاعات شخصی',
    ur_PK: 'ذاتی ڈیٹا'
  },
  今日: {
    en_US: 'Today',
    ar_SA: 'اليوم',
    tr_TR: 'Bugün',
    id_ID: 'Hari Ini',
    pt_BR: 'Hoje',
    ru_RU: 'Сегодня',
    uz_UZ: 'Bugun',
    fa_IR: 'امروز',
    ur_PK: 'آج'
  },
  昨日: {
    en_US: 'Yesterday',
    tr_TR: 'Dün',
    ar_SA: 'امس',
    id_ID: 'Kemarin',
    pt_BR: 'Ontem',
    ru_RU: 'Вчера',
    uz_UZ: 'Kecha',
    fa_IR: 'پیش',
    ur_PK: 'کل'
  },
  本周: {
    en_US: 'This Week',
    tr_TR: 'Bu hafta',
    ar_SA: 'الأسبوع الحالي',
    id_ID: 'Minggu Ini',
    pt_BR: 'Esta Semana',
    ru_RU: 'На этой неделе',
    uz_UZ: 'Bu hafta',
    fa_IR: 'هفته اینجا',
    ur_PK: 'اس ہفتہ'
  },
  上周: {
    en_US: 'Last Week',
    tr_TR: 'Geçen hafta',
    ar_SA: 'الأسبوع الماضي',
    id_ID: 'Minggu Lalu',
    pt_BR: 'Semana Passada',
    ru_RU: 'Прошлая неделя',
    uz_UZ: 'O‘tgan hafta',
    fa_IR: 'هفته گذشته',
    ur_PK: 'گزشتہ ہفتہ'
  },
  本月: {
    en_US: 'This Month',
    tr_TR: 'Bu Ay',
    ar_SA: 'الشهر الحالي',
    id_ID: 'Bulan Ini',
    pt_BR: 'Este Mês',
    ru_RU: 'В этом месяце',
    uz_UZ: 'Bu oy',
    fa_IR: 'این ماه',
    ur_PK: 'اس مہینہ'
  },
  上月: {
    en_US: 'Last Month',
    tr_TR: 'Geçen ay',
    ar_SA: 'الشهر الماضي',
    id_ID: 'Bulan Lalu',
    pt_BR: 'Mês Passado',
    ru_RU: 'Прошлый месяц',
    uz_UZ: 'O‘tgan oy',
    fa_IR: 'ماه گذشته',
    ur_PK: 'گزشتہ مہینہ'
  },
  小时: {
    en_US: 'Hours',
    tr_TR: 'Saatler',
    ar_SA: 'ساعد',
    id_ID: 'Jam',
    pt_BR: 'Horas',
    ru_RU: 'Часы',
    uz_UZ: 'Soatlar',
    fa_IR: 'ساعت',
    ur_PK: 'گھنٹے'
  },
  分钟: {
    en_US: 'Minutes',
    tr_TR: 'Dakikalar',
    ar_SA: 'دقيقد',
    id_ID: 'Menit',
    pt_BR: 'Minutos',
    ru_RU: 'Минуты',
    uz_UZ: 'Daqiqalar',
    fa_IR: 'دقیقه',
    ur_PK: 'منٹ'
  },
  秒: {
    en_US: 'Seconds',
    tr_TR: 'Saniyeler',
    ar_SA: 'ثانية',
    id_ID: 'Detik',
    pt_BR: 'Segundos',
    ru_RU: 'Секунды',
    uz_UZ: 'Soniyalar',
    fa_IR: 'ثانیه',
    ur_PK: 'سیکنڈ'
  },
  utc_tips: {
    zh_CN: '基于Utc+3 时区统计数据',
    en_US: 'Based on Utc+3 time zone statistics',
    tr_TR: 'Utc+3 saat dilimi istatistiklerine göre',
    ar_SA: 'استنادًا إلى إحصائيات المنطقة الزمنية Utc+3',
    id_ID: 'Berdasarkan statistik zona waktu Utc+3',
    pt_BR: 'Com base nas estatísticas de fuso horário UTC+3',
    ru_RU: 'На основе статистики часовых поясов Utc+3',
    uz_UZ: 'UTC+3 vaqt zonalari statistikasi asosida',
    fa_IR: 'سنسورهای زمانی بر پایه Utc+3',
    ur_PK: 'Utc+3 ٹائم زون کے اعداد و شمار پر مبنی'
  },
  期间收入: {
    en_US: 'Period Revenue',
    ar_SA: 'إيرادات الفترة',
    tr_TR: 'Dönem gelir',
    id_ID: 'Pendapatan Periode',
    pt_BR: 'Receita do Período',
    ru_RU: 'Доход за период',
    uz_UZ: 'O‘quv-periodi xarid',
    fa_IR: 'روزانه هزینه',
    ur_PK: 'مدت کی آمدنی'
  },
  当前期间: {
    en_US: 'Current Period',
    ar_SA: 'الفترة الحالية',
    tr_TR: 'Mevcut dönem',
    id_ID: 'Periode Saat Ini',
    pt_BR: 'Período Atual',
    ru_RU: 'Текущий период',
    uz_UZ: 'O‘quv-periodi',
    fa_IR: 'فاز حالی',
    ur_PK: 'موجودہ مدت'
  },
  当期收入: {
    en_US: 'Current Period Revenue',
    ar_SA: 'إيرادات الفترة الحالية',
    tr_TR: 'Mevcut dönem gelir',
    id_ID: 'Pendapatan Periode Saat Ini',
    pt_BR: 'Receita do Período Atual',
    ru_RU: 'Доход за текущий период',
    uz_UZ: 'O‘quv-periodi xarid',
    fa_IR: 'روزانه هزینه فعلی',
    ur_PK: 'موجودہ مدت کی آمدنی'
  },
  末期: {
    en_US: 'Last Period',
    ar_SA: 'الفترة الماضية',
    tr_TR: 'Önceki dönem',
    id_ID: 'Periode Sebelumnya',
    pt_BR: 'Período Anterior',
    ru_RU: 'Прошлый период',
    uz_UZ: 'Avvalgi period',
    fa_IR: 'فاز گذشته',
    ur_PK: 'پچھلی مدت'
  },
  上期收入: {
    en_US: 'Last Period Revenue',
    ar_SA: 'إيرادات الفترة الماضية',
    tr_TR: 'Önceki dönem gelir',
    id_ID: 'Pendapatan Periode Sebelumnya',
    pt_BR: 'Receita do Período Anterior',
    ru_RU: 'Доход за прошлый период',
    uz_UZ: 'Avvalgi period xarid',
    fa_IR: 'روزانه هزینه گذشته',
    ur_PK: 'گزشتہ مدت کی آمدنی'
  },
  今日收入: {
    en_US: 'Today Revenue',
    ar_SA: 'إيرادات اليوم',
    tr_TR: 'Bugün gelir',
    id_ID: 'Pendapatan Hari Ini',
    pt_BR: 'Receita de Hoje',
    ru_RU: 'Доход за сегодня',
    uz_UZ: 'Bugun xarid',
    fa_IR: 'روزانه هزینه امروز',
    ur_PK: 'آج کی آمدنی'
  },
  昨日收入: {
    en_US: 'Yesterday Revenue',
    ar_SA: 'إيرادات الأمس',
    tr_TR: 'Dün gelir',
    id_ID: 'Pendapatan Kemarin',
    pt_BR: 'Receita de Ontem',
    ru_RU: 'Доход за вчера',
    uz_UZ: 'Kecha xarid',
    fa_IR: 'روزانه هزینه پیش',
    ur_PK: 'کل کی آمدنی'
  },
  本周收入: {
    en_US: 'This Week Revenue',
    ar_SA: 'إيرادات الأسبوع الحالي',
    tr_TR: 'Bu hafta gelir',
    id_ID: 'Pendapatan Minggu Ini',
    pt_BR: 'Receita de Esta Semana',
    ru_RU: 'Доход за эту неделю',
    uz_UZ: 'Bu hafta xarid',
    fa_IR: 'روزانه هزینه هفته اینجا',
    ur_PK: 'اس ہفتہ کی آمدنی'
  },
  上周收入: {
    en_US: 'Last Week Revenue',
    ar_SA: 'إيرادات الأسبوع الماضي',
    tr_TR: 'Geçen hafta gelir',
    id_ID: 'Pendapatan Minggu Lalu',
    pt_BR: 'Receita de Semana Passada',
    ru_RU: 'Доход за прошлую неделю',
    uz_UZ: 'O‘tgan hafta xarid',
    fa_IR: 'روزانه هزینه هفته گذشته',
    ur_PK: 'گزشتہ ہفتہ کی آمدنی'
  },
  本月收入: {
    en_US: 'This Month Revenue',
    ar_SA: 'إيرادات الشهر الحالي',
    tr_TR: 'Bu ay gelir',
    id_ID: 'Pendapatan Bulan Ini',
    pt_BR: 'Receita de Este Mês',
    ru_RU: 'Доход за этот месяц',
    uz_UZ: 'Bu oy xarid',
    fa_IR: 'روزانه هزینه این ماه',
    ur_PK: 'اس مہینے کی آمدنی'
  },
  上月收入: {
    en_US: 'Last Month Revenue',
    ar_SA: 'إيرادات الشهر الماضي',
    tr_TR: 'Geçen ay gelir',
    id_ID: 'Pendapatan Bulan Lalu',
    pt_BR: 'Receita de Mês Passado',
    ru_RU: 'Доход за прошлый месяц',
    uz_UZ: 'O‘tgan oy xarid',
    fa_IR: 'روزانه هزینه ماه گذشته',
    ur_PK: 'گزشتہ مہینے کی آمدنی'
  },
  每日收入: {
    en_US: 'Daily Revenue',
    ar_SA: 'إيرادات اليومي',
    tr_TR: 'Günlük gelir',
    id_ID: 'Pendapatan Harian',
    pt_BR: 'Receita Diária',
    ru_RU: 'Дневной доход',
    uz_UZ: 'Kunlik xarid',
    fa_IR: 'روزانه هزینه روزانه',
    ur_PK: 'روزانہ کی آمدنی'
  },
  每周收入: {
    en_US: 'Weekly Revenue',
    ar_SA: 'إيرادات الأسبوعي',
    tr_TR: 'Haftalık gelir',
    id_ID: 'Pendapatan Mingguan',
    pt_BR: 'Receita Semanal',
    ru_RU: 'Недельный доход',
    uz_UZ: 'Haftalik xarid',
    fa_IR: 'روزانه هزینه هفتگی',
    ur_PK: 'ہفتہ وار آمدنی'
  },
  每月收入: {
    en_US: 'Monthly Revenue',
    ar_SA: 'إيرادات الشهري',
    tr_TR: 'Aylık gelir',
    id_ID: 'Pendapatan Bulanan',
    pt_BR: 'Receita Mensal',
    ru_RU: 'Месячный доход',
    uz_UZ: 'Oyligi xarid',
    fa_IR: 'روزانه هزینه ماهانه',
    ur_PK: 'ماہانہ آمدنی'
  },
  "提款金额": {
    "zh_CN": "提款金额",
    "en_US": "Withdrawal Amount",
    "ar_SA": "مبلغ السحب",
    "tr_TR": "Çekilecek Miktar",
    "ru_RU": "Сумма вывода средств",
    "uz_UZ": "Pulni qaytarib olish miqdori",
    "id_ID": "Jumlah Pengunduran",
    "pt_BR": "Montante de Retirada",
    "fa_IR": "مقدار برداشتن",
    "ur_PK": "دفع کی مقدار"
  },
  "订单号": {
    "zh_CN": "订单号",
    "en_US": "Order ID",
    "ar_SA": "رقم الطلب",
    "tr_TR": "Sipariş Kimliği",
    "ru_RU": "Айди заказа",
    "uz_UZ": "Aidi buyurtmasi",
    "id_ID": "Perintah No.",
    "pt_BR": "Número de ordem.",
    "fa_IR": "دستور نه",
    "ur_PK": "آرڈر نمبر"
  },
  "提款申请时间": {
    "zh_CN": "提款申请时间",
    "en_US": "Withdrawal request time",
    "ar_SA": "وقت التقديم السحب ",
    "tr_TR": "Para çekme talebi süresi",
    "ru_RU": "Время запроса на вывод средств",
    "uz_UZ": "Pulni qaytarib olish uchun so'rov vaqti",
    "id_ID": "Waktu pengunduran aplikasi",
    "pt_BR": "Tempo de retirada do pedido",
    "fa_IR": "برداشتن زمان کاربرد",
    "ur_PK": "کैش آউٹ کے درخواست کا وقت"
  },
  "你的提现订单有新进展": {
    "zh_CN": "你的提现订单有新进展",
    "en_US": "New changes to your withdrawal order.",
    "ar_SA": "هناك تطورات جديدة في طلبك السحب .",
    "tr_TR": "Çıkarma emriniz yeni ilerleme var.",
    "ru_RU": "Обновлен статус заказа на вывод средств.",
    "uz_UZ": "Pulni qaytarib olish uchun buyurtma holati yangilandi.",
    "id_ID": "Ada perkembangan baru dalam perintah penarikanmu",
    "pt_BR": "Houve novos desenvolvimentos na sua ordem de retirada",
    "fa_IR": "توسعه جدید در دستور بازداشتن شما وجود داشته است",
    "ur_PK": "آپ کے منہ پھیرنے کے قانون میں نو تغییرات موجود ہیں"
  },
  "代理上传了汇款凭证,请尽快确认": {
    "zh_CN": "代理上传了汇款凭证,请尽快确认",
    "en_US": "Seller has uploaded the payment proof, please confirm details.",
    "ar_SA": " وكيل الشحت تم تحميل صورة التحويل ، الارجاء تاكيد اسرع",
    "tr_TR": "Ajan gönderme verici yükledi, detayları görüntüle",
    "ru_RU": " Реселлер отправил ваучер — подтвердите срочно.",
    "uz_UZ": "Sotuvchi vaucherni yubordi-zudlik bilan tasdiqlang.",
    "id_ID": "Agen telah mengunggah surat pengiriman, silakan konfirmasi secepat mungkin",
    "pt_BR": "O agente carregou o voucher de remessa, por favor confirme o mais rápido possível",
    "fa_IR": "مامور واچر انتقال رو آپلود کرده لطفا به محض اينکه ممکنه تاييد کنيد",
    "ur_PK": "ایجنٹ نے ریٹنس واچر کو آلڈ کیا ہے، لطفا جہاں زود ممکن ہے تصدیق کرو"
  },
  "【该笔提现订单已完成】": {
    "zh_CN": "【该笔提现订单已完成】",
    "en_US": "The withdrawal order has been completed.",
    "ar_SA": "[تم إكمال هذا الطلب]",
    "tr_TR": "Para çekme emri tamamlandı.",
    "ru_RU": "Заказ на вывод средств был выполнен.",
    "uz_UZ": "Pulni qaytarib olish uchun buyurtma bajarildi.",
    "id_ID": "Perintah penarikan sudah selesai.",
    "pt_BR": "A ordem de retirada foi completada",
    "fa_IR": "دستور بازداشتن تموم شده است",
    "ur_PK": "دفع کا حکم پورا ہوگیا ہے"
  },
  "代理拒接该笔提现订单": {
    "zh_CN": "代理拒接该笔提现订单",
    "en_US": "The seller has rejected the withdrawal order.",
    "ar_SA": "رفض الوكيل  السحب",
    "tr_TR": "Satıcı cayma talebini reddetti.",
    "ru_RU": "Реселлер отклонил заявку на вывод средств.",
    "uz_UZ": "Sotuvchi pulni qaytarib olish to'g'risidagi arizani rad etdi.",
    "id_ID": "Agen menolak menerima perintah penarikan diri",
    "pt_BR": "O agente recusou-se a aceitar a ordem de retirada",
    "fa_IR": "مامور از دستور بازداشتن قبول نکرد",
    "ur_PK": "اگنٹر نے منع کیا کہ منہ پھیرنے کا حکم قبول کرے"
  },
  "该笔提现订单已完成": {
    "zh_CN": "该笔提现订单已完成",
    "en_US": "The withdrawal order has been completed.",
    "ar_SA": "تم الانتهاء هذا الطلب السحب",
    "tr_TR": "Para çekme emri tamamlandı.",
    "ru_RU": "Заказ на вывод средств был выполнен.",
    "uz_UZ": "Pulni qaytarib olish uchun buyurtma bajarildi.",
    "id_ID": "Perintah penarikan sudah selesai.",
    "pt_BR": "A ordem de retirada foi completada",
    "fa_IR": "دستور بازداشتن تموم شده است",
    "ur_PK": "دفع کا حکم پورا ہوگیا ہے"
  },
  "【有用户发起提现申请】": {
    "zh_CN": "【有用户发起提现申请】",
    "en_US": "[A user initiated a withdrawal request]",
    "ar_SA": "[لدي مستخدم تقديم الطلب السحب]",
    "tr_TR": "[Bir kullanıcı bir para çekme isteği başlattı]",
    "ru_RU": "[Пользователь инициировал запрос на вывод средств]",
    "uz_UZ": "[Foydalanuvchi pulni qaytarib olish so'rovini boshladi]",
    "id_ID": "Pengguna memulai permintaan penarikan",
    "pt_BR": "O utilizador inicia o pedido de retirada",
    "fa_IR": "کاربر درخواست بازداشتن را آغاز می‌کند",
    "ur_PK": "کارساز پھیرنے کی خواہش پیدا کرتا ہے"
  },
  "【该笔提现订单用户申诉不到账】": {
    "zh_CN": "【该笔提现订单用户申诉不到账】",
    "en_US": "[User of this withdrawal order complain not receiving the money].",
    "ar_SA": " [اشتكى المستخدم لم يستلم الراتب في هذا الطلب ]",
    "tr_TR": "[Bu para çekme emrinin kullanıcısı parayı alamadığından şikayetçi].",
    "ru_RU": "[Пользователь этого заказа на вывод средств жалуется на неполучение денег].",
    "uz_UZ": "[Ushbu pul olish buyurtmasidan foydalanuvchi pul olmaganidan shikoyat qiladi].",
    "id_ID": "Panggilan pengguna untuk perintah penarikan tidak dapat diterima",
    "pt_BR": "O recurso do usuário para a ordem de retirada não pode ser recebido",
    "fa_IR": "دعوت کاربر برای دستور بازداشتن نمی‌تواند پذیرفته شود",
    "ur_PK": "استعمال کی آواز واپس کرنے کے لئے نہیں پائی جاتی"
  },
  "代理已处理该笔提现申请": {
    "zh_CN": "代理已处理该笔提现申请",
    "en_US": "The seller has processed the withdrawal request.",
    "ar_SA": " لقد قام الوكيل بمعالجة هذا الطلب",
    "tr_TR": "Satıcı cayma talebinizi işleme koydu.",
    "ru_RU": "Реселлер обработал запрос на вывод средств.",
    "uz_UZ": "Sotuvchi pulni qaytarib olish so'rovini ko'rib chiqdi.",
    "id_ID": "Agen telah memproses permintaan penarikan",
    "pt_BR": "O agente processou o pedido de retirada",
    "fa_IR": "مامور درخواست برداشتن",
    "ur_PK": "اگنٹر نے پھیرنے کی خواہش کی پروسس کی ہے"
  },
  "请选择角色身份": {
    "zh_CN": "请选择角色身份",
    "en_US": "Please select your role identity",
    "ar_SA": "الرجاء اختيار الدور",
    "tr_TR": "Lütfen rol kimliğinizi seçin",
    "ru_RU": "Пожалуйста, выберите свою роль.",
    "uz_UZ": "Iltimos, rolingizni tanlang.",
    "id_ID": "Silakan pilih identitas peran",
    "pt_BR": "Seleccione por favor uma identidade de função",
    "fa_IR": "لطفاً یک هویت نقش انتخاب کنید",
    "ur_PK": "کृपا کرکے رول کی شناخت منتخب کریں"
  },
  "充值代理": {
    "zh_CN": "充值代理",
    "en_US": "Coin Seller",
    "ar_SA": "وكيل الشحن ",
    "tr_TR": "Altın Satıcısı ",
    "ru_RU": "Реселлер монет",
    "uz_UZ": "Tangalar sotuvchisi",
    "id_ID": "Agen muat ulang",
    "pt_BR": "Agente de recarga",
    "fa_IR": "عده انتقال پول",
    "ur_PK": "اسٹیومر"
  },
  "主播": {
    "zh_CN": "主播",
    "en_US": "Hosts",
    "ar_SA": "المضيف ",
    "tr_TR": "Ev sahipleri",
    "ru_RU": "Ведущие",
    "uz_UZ": "Taqdimotchilar",
    "id_ID": "Anchor TV",
    "pt_BR": "Âncora de TV",
    "fa_IR": "مرکز تلویزیون",
    "ur_PK": "تلویزیون آنچر"
  },
  "提款代理": {
    "zh_CN": "提款代理",
    "en_US": "Withdrawal Seller",
    "ar_SA": "وكيل السحب الراتب",
    "tr_TR": "Para Çekme Satıcısı",
    "ru_RU": "Реселлер вывод средств",
    "uz_UZ": "Sotuvchi pulni qaytarib olish",
    "id_ID": "Agen penarikan",
    "pt_BR": "Agente de retirada",
    "fa_IR": "مامور حذف کردن",
    "ur_PK": "واٹروال اگنٹ"
  },
  "提款": {
    "zh_CN": "提款",
    "en_US": "Withdraw",
    "ar_SA": "السحب",
    "tr_TR": "Geri çekilmek",
    "ru_RU": "Выводить",
    "uz_UZ": "Chiqarish",
    "id_ID": "menarik uang",
    "pt_BR": "sacar dinheiro",
    "fa_IR": "پول کشیدن",
    "ur_PK": "پول ڈرو"
  },
  "提款方式": {
    "zh_CN": "提款方式",
    "en_US": "Withdrawal method",
    "ar_SA": "طرق الاستلام ",
    "tr_TR": "Para çekme yöntemi",
    "ru_RU": "Способ вывода средств",
    "uz_UZ": "Mablag'larni chiqarish usuli",
    "id_ID": "Metode tarik",
    "pt_BR": "Método de retirada",
    "fa_IR": "روش برداشت",
    "ur_PK": "drawable method"
  },
  "添加提款方式": {
    "zh_CN": "添加提款方式",
    "en_US": "Add withdrawal method",
    "ar_SA": "إضافة طريقة الاستلام ",
    "tr_TR": "Para çekme yöntemini ekle",
    "ru_RU": "Добавить способ вывода средств",
    "uz_UZ": "Pulni qaytarib olish usulini qo'shing",
    "id_ID": "Tambah metode penarikan",
    "pt_BR": "Adicionar o método de retirada",
    "fa_IR": "افزودن روش بازداشتن",
    "ur_PK": "پھیرنے کا طریقہ اضافہ کریں"
  },
  "提款记录": {
    "zh_CN": "提款记录",
    "en_US": "Withdrawal Record",
    "ar_SA": "سجل السحب ",
    "tr_TR": "Para Çekme Kaydı",
    "ru_RU": "Запись о выводе средств",
    "uz_UZ": "Pulni qaytarib olish to'g'risidagi yozuv",
    "id_ID": "Rekaman Keluaran",
    "pt_BR": "Registo de Retirada",
    "fa_IR": "ضبط حذف کردن",
    "ur_PK": "روک لیکن"
  },
  "账户管理": {
    "zh_CN": "账户管理",
    "en_US": "Account Management",
    "ar_SA": "إدارة الحساب ",
    "tr_TR": "Hesap Yönetimi",
    "ru_RU": "Управление аккаунта",
    "uz_UZ": "Hisobni boshqarish",
    "id_ID": "Manajemen Akaun",
    "pt_BR": "Gestão de Contas",
    "fa_IR": "مدیریت حساب",
    "ur_PK": "حساب مدیریت"
  },
  "发起提款": {
    "zh_CN": "发起提款",
    "en_US": "Initiate withdrawal",
    "ar_SA": "طلب السحب ",
    "tr_TR": "Geri çekilmeyi başlat",
    "ru_RU": "Инициировать вывод средств",
    "uz_UZ": "Pul mablag'larini qaytarib olishni boshlang",
    "id_ID": "Mulai penarikan",
    "pt_BR": "Iniciar a retirada",
    "fa_IR": "آغاز بازداشتن",
    "ur_PK": "پھیرنا شروع کرنا"
  },
  "提款订单被取消": {
    "zh_CN": "提款订单被取消",
    "en_US": "Withdrawal order cancelled",
    "ar_SA": "تم الغاء السحب",
    "tr_TR": "Para çekme emri iptal edildi",
    "ru_RU": "Приказ о выводе средств отменен",
    "uz_UZ": "Mablag'larni chiqarish to'g'risidagi buyruq bekor qilindi",
    "id_ID": "Perintah penarikan dibatalkan",
    "pt_BR": "Ordem de retirada cancelada",
    "fa_IR": "سفارش برداشتن کنسل شد",
    "ur_PK": "ٹوٹ ورڈ کاٹ دی گئی"
  },
  "最大值": {
    "zh_CN": "最大值",
    "en_US": "Maximum Amount",
    "ar_SA": "الحد الأقصى",
    "tr_TR": "Maksimum Tutar",
    "ru_RU": "Максимальная сумма",
    "uz_UZ": "Maksimal miqdor",
    "id_ID": "Nilai maksimum",
    "pt_BR": "Valor máximo",
    "fa_IR": "بالاترین ارزش",
    "ur_PK": "Maximum value"
  },
  "选择提款代理": {
    "zh_CN": "选择提款代理",
    "en_US": "Select withdrawal seller",
    "ar_SA": "اختر وكيل الشحن ",
    "tr_TR": "Para çekme satıcısını seçin",
    "ru_RU": "Выберите реселлера вывод средств",
    "uz_UZ": "Sotuvchini tanlang pulni qaytarib olish",
    "id_ID": "Pilih agen penarikan",
    "pt_BR": "Escolha um agente de retirada",
    "fa_IR": "انتخاب یک مامور بازداشتن",
    "ur_PK": "پھیرنے کا اگنٹ انتخاب کریں"
  },
  "单笔最少提取": {
    "zh_CN": "单笔最少提取",
    "en_US": "Minimum amount each time",
    "ar_SA": "الحد الأدنى للسحب في المر",
    "tr_TR": "Her seferinde minimum miktar",
    "ru_RU": "Минимальная сумма каждый раз",
    "uz_UZ": "Har safar minimal miqdor",
    "id_ID": "Ekstrasi minimum per transaksi",
    "pt_BR": "Extracção mínima por transacção",
    "fa_IR": "کمینه اخراج از هر تجارت",
    "ur_PK": "ٹرانسکیٹ کے سب سے کم اضافہ"
  },
  "已超本周提现次数": {
    "zh_CN": "已超本周提现次数",
    "en_US": "Withdrawals have exceeded this week's limit xxx",
    "ar_SA": "تجاوز عدد المارت السحب هذا الأسبوع",
    "tr_TR": "Para çekme işlemleri bu haftanın limitini aştı xxx",
    "ru_RU": "Вы превысили лимит на вывод средств на этой неделе XXX",
    "uz_UZ": "Siz bu hafta xxx pul olish limitidan oshib ketdingiz",
    "id_ID": "Pengunduran telah melebihi batas minggu ini",
    "pt_BR": "Retiradas ultrapassaram o limite desta semana",
    "fa_IR": "حذف کردن محدودیت این هفته بیشتر از حد",
    "ur_PK": "اس ہفتے کی حد سے زیادہ زیادہ"
  },
  "单次最少可提款钻石数xxx": {
    "zh_CN": "单次最少可提款钻石数xxx",
    "en_US": "Minimum amount of diamonds that can be withdrawn at a time xxx",
    "ar_SA": "الحد الأدنى عدة السحب الماسات في نفس المرة ",
    "tr_TR": "Bir seferde çekilebilecek minimum elmas miktarı xxx",
    "ru_RU": "Минимальный лимит алмазов за снятие XXX",
    "uz_UZ": "XXX olib tashlash uchun minimal olmos chegarasi",
    "id_ID": "Bilangan berlian minimum yang dapat ditarik dalam transaksi tunggal xxx",
    "pt_BR": "Número mínimo de diamantes que podem ser retirados em uma única transação xxx",
    "fa_IR": "حداقل تعداد الماسی که در یک عملیات می توان آن را ببرداشت کرد، مقدار آن xxx است",
    "ur_PK": "ایک ٹرانسکیٹ xxx میں چھوڑ سکتے ہیں"
  },
  "提款申请发起成功，等待代理确认": {
    "zh_CN": "提款申请发起成功，等待代理确认",
    "en_US": "Withdrawal request initiated successfully, waiting for seller to confirm",
    "ar_SA": "تم مقدم طلب في انتظار الوكيل يتأكد",
    "tr_TR": "Para çekme talebi başarıyla başlatıldı, satıcının onaylaması bekleniyor",
    "ru_RU": "Запрос на вывод средств успешно инициирован, дождитесь подтверждения от реселлера",
    "uz_UZ": "Pulni qaytarib olish so'rovi muvaffaqiyatli boshlandi, sotuvchidan tasdiqlashni kuting",
    "id_ID": "Permintaan mundur dimulai dengan sukses, menunggu konfirmasi agen",
    "pt_BR": "Pedido de retirada iniciado com sucesso, aguardando confirmação do agente",
    "fa_IR": "درخواست برداشتن به موفقیت شروع شد، منتظر تایید مامور",
    "ur_PK": "اگنٹر کی تصدیق کے لئے انتظار کر رہے ہیں"
  },
  "确认": {
    "zh_CN": "确认",
    "en_US": "Confirmation",
    "ar_SA": "تاكيد ",
    "tr_TR": "Onay",
    "ru_RU": "Подтверждение",
    "uz_UZ": "Tasdiqlash",
    "id_ID": "konfirmasi",
    "pt_BR": "confirmar",
    "fa_IR": "تصدیق کنید",
    "ur_PK": "تصدیق کریں"
  },
  "提现记录": {
    "zh_CN": "提现记录",
    "en_US": "Withdrawal record",
    "ar_SA": "سجل الانسحاب",
    "tr_TR": "Para çekme kaydı",
    "ru_RU": "Запись о выводе средств",
    "uz_UZ": "Pulni qaytarib olish to'g'risidagi yozuv",
    "id_ID": "Rekaman penarikan",
    "pt_BR": "Registo de retirada",
    "fa_IR": "ضبط",
    "ur_PK": "روک"
  },
  "待处理": {
    "zh_CN": "待处理",
    "en_US": "Pending",
    "ar_SA": "في الانتظار",
    "tr_TR": "Askıda ",
    "ru_RU": "В ожидании",
    "uz_UZ": "Intizorlik bilan",
    "id_ID": "Tertunda",
    "pt_BR": "Pendente",
    "fa_IR": "در حال بررسی",
    "ur_PK": "درخواست زیر غور"
  },
  "申请中": {
    "zh_CN": "申请中",
    "en_US": "Applying",
    "ar_SA": "تقديم",
    "tr_TR": "Başvuru",
    "ru_RU": "Применение",
    "uz_UZ": "Murojaat qilinmoqda",
    "id_ID": "Mengajukan",
    "pt_BR": "Solicitando",
    "fa_IR": "اعمال کردن",
    "ur_PK": 'درخواست دے رہا ہے۔'
  },
  "进行中": {
    "zh_CN": "进行中",
    "en_US": "In progress",
    "ar_SA": "في تَقَدم",
    "tr_TR": "Devam etmekte",
    "ru_RU": "В процессе",
    "uz_UZ": "Jarayonda",
    "id_ID": "in progress",
    "pt_BR": "em curso",
    "fa_IR": "در حال پیشرفت",
    "ur_PK": "در حال حاضر"
  },
  "售后": {
    "zh_CN": "售后",
    "en_US": "After sale",
    "ar_SA": "الاشكوي في السحب",
    "tr_TR": "Satış sonrası",
    "ru_RU": "Послепродажное обслуживание",
    "uz_UZ": "Sotishdan keyingi xizmat",
    "id_ID": "Setelah Penjualan",
    "pt_BR": "Pós-venda",
    "fa_IR": "بعد از فروش",
    "ur_PK": "فروخت کے بعد"
  },
  "完成": {
    "zh_CN": "完成",
    "en_US": "Completed",
    "ar_SA": "خلاص",
    "tr_TR": "Tamamlanmış",
    "ru_RU": "Завершенный",
    "uz_UZ": "Tugallangan",
    "id_ID": "selesai",
    "pt_BR": "completo",
    "fa_IR": "کامل",
    "ur_PK": "پورا"
  },
  "联系代理": {
    "zh_CN": "联系代理",
    "en_US": "Contact Seller",
    "ar_SA": "اتصل بالوكيل",
    "tr_TR": "Satıcıyla İletişime Geçin",
    "ru_RU": "Связаться с реселлером",
    "uz_UZ": "Sotuvchi bilan bog'laning",
    "id_ID": "Agen Kontak",
    "pt_BR": "Contactar o Agente",
    "fa_IR": "مامور ارتباط",
    "ur_PK": "اگنٹ"
  },
  "前往app内进行沟通": {
    "zh_CN": "前往app内进行沟通",
    "en_US": "Go to Hoby to communicate",
    "ar_SA": "انتقل إلى داخل التطبيق للتواصل",
    "tr_TR": "İletişim kurmak için Hoby'e gidin",
    "ru_RU": "Обратитесь к Hoby, чтобы пообщаться",
    "uz_UZ": "Muloqot qilish uchun Hoby bilan bog'laning",
    "id_ID": "Pergi ke aplikasi komunikasi",
    "pt_BR": "Ir para a aplicação para comunicação",
    "fa_IR": "برو به کاربرد برای ارتباط",
    "ur_PK": "ارتباط کے لئے آپپ میں جاؤ"
  },
  "复制成功": {
    "zh_CN": "复制成功",
    "en_US": "Copy Successfully",
    "ar_SA": "نجاح النسخ",
    "tr_TR": "Kopyalama Başarıyla Gerçekleştirildi",
    "ru_RU": "Успешное копирование",
    "uz_UZ": "Muvaffaqiyatli nusxalash",
    "id_ID": "Mengulangi Sukses",
    "pt_BR": "Replicar o Sucesso",
    "fa_IR": "تکرار موفقیت",
    "ur_PK": "موفقیت کے ساتھ ردیابی کی جاتی ہے"
  },
  tips2: {
    "zh_CN": "代理已转账，实际收款可能会延迟1~2小时到账，您可以点击下面的“未到/少到”进行申诉。代理确认转账后，没有确认的订单将在x天后自动确认。",
    "en_US": "The seller has made the transfer, the actual receipt may be delayed for 1~2 hours, you can click on the ‘Not Arrived / Less Arrived’ below to file a complaint. After the seller confirms the transfer, orders that have not been confirmed will be automatically confirmed after x days.",
    "ar_SA": "تم تحويل الوكيل الشحن الاموال ، قد يتاخر 1-2 ساعة استلام  ، يمكنك اضغط علي تالية  \"لم يتم الاستلام/ ناقص \"   لطلب الشكوي ، بعد يتم تاكيد تحويل الوكيل سيتم انتهاء الطلب غير تاكيد تلقائيا بعد x أيام",
    "tr_TR": "Satıcı transferi yaptı, gerçek makbuz 1~2 saat gecikebilir, şikayette bulunmak için aşağıdaki ‘Gelmedi / Daha Az Geldi’ye tıklayabilirsiniz. Satıcı transferi onayladıktan sonra, ",
    "ru_RU": "Реселлер осуществил перевод, фактическое получение может быть отложено на 1-2 часа, вы можете нажать на кнопку \"Не поступило / Поступило меньше\" ниже, чтобы подать жалобу. После того, как реселлер подтвердит перевод, заказы, которые не были подтверждены, будут автоматически подтверждены через X дней.",
    "uz_UZ": "Sotuvchi pul o'tkazmasini amalga oshirdi, haqiqiy qabul qilish 1-2 soatga kechiktirilishi mumkin, shikoyat qilish uchun quyidagi \"qabul qilinmagan / qabul qilinmagan\" tugmasini bosishingiz mumkin. Sotuvchi pul o'tkazmasini tasdiqlaganidan so'ng, tasdiqlanmagan buyurtmalar x kundan keyin avtomatik ravishda tasdiqlanadi.",
    "id_ID": "Agen telah memindahkan dana, tetapi penerimaan sebenarnya mungkin ditunda 1-2 jam. Anda dapat klik pada \"tidak diterima/tidak diterima\" di bawah untuk mengajukan sebuah appeal. Setelah agen mengkonfirmasi transfer, perintah tidak dikonfirmasi akan dikonfirmasi secara otomatis dalam x hari.",
    "pt_BR": "O agente transferiu os fundos, mas o recibo real pode ser adiado de 1 a 2 horas. Você pode clicar em \"não recebido/não recebido\" abaixo para apresentar um recurso. Depois que o agente confirmar a transferência, os pedidos não confirmados serão confirmados automaticamente em x dias.",
    "fa_IR": "مامور پول را انتقال کرده است، ولی دریافت واقعی ممکن است تا ۱-۲ ساعت تأخیر شود. می توانید روی \"دریافت نشده/دریافت نشده\" پایین فشار دهید تا دریافت آگهی کنید. بعد از اينکه مامور انتقال رو تاييد کنه، دستورات ناتاييد توي روز x تاييد ميشه.",
    "ur_PK": "اگنٹر نے فوندز کو ترنسیٹ کر دیا ہے، لیکن حقیقی ریسپیٹ 1-2 گھنٹے کے ذریعہ دیر ہو سکتی ہے. آپ نیچے \"قبول نہیں کیا گیا/نہیں گیا\" پر کلک کر سکتے ہیں۔ اگنٹر ترنسیٹر کی تصدیق کرنے کے بعد، غیر تصدیق کی دستور X دنوں میں اپنے ساتھ تصدیق کی جائے گی."
  },
  tips3: {
    "zh_CN": "待提款用户确认提款金额到账，没有确认的订单将在提款申请发起的x天后自动确认完成",
    "en_US": "After the user who is waiting for the withdrawal confirms that the withdrawal amount has reached the account, the order without confirmation will be automatically confirmed after x days from the date of the withdrawal request.",
    "ar_SA": "في انتظار تأكيد مستخدم السحب على استلام مبلغ السحب. سيتم تأكيد الطلبات غير المؤكدة تلقائيًا بعد x أيام من بدء طلب السحب.",
    "tr_TR": "Çekimi bekleyen kullanıcı çekim tutarının hesabına ulaştığını onayladıktan sonra, onay alınmadan verilen sipariş, tarihten itibaren x gün sonra otomatik olarak onaylanacaktır. ",
    "ru_RU": "После того, как реселлер вывод средств загрузит документ о переводе средств, даже если ведущий не нажмет кнопку подтверждения заказа, этот заказ будет автоматически подтвержден через X дней.",
    "uz_UZ": "Sotuvchi pulni qaytarib olgandan so'ng, uy egasi buyurtmani tasdiqlash tugmachasini bosmasa ham, pul o'tkazmasi to'g'risidagi hujjatni yuklaydi, bu buyurtma x kundan keyin avtomatik ravishda tasdiqlanadi.",
    "id_ID": "Menunggu konfirmasi jumlah penarikan oleh pengguna penarikan, perintah tidak dikonfirmasi akan secara otomatis dikonfirmasi x hari setelah permintaan penarikan dimulai",
    "pt_BR": "Na pendência da confirmação do valor da retirada pelo usuário que retirou, as encomendas não confirmadas serão confirmadas automaticamente x dias após o início do pedido de retirada",
    "fa_IR": "باقی مانده تایید مقدار بازداشتن از طریق کاربر بازداشتن، دستورات ناتایید x روزهای بعد از خواسته بازداشتن آغاز شود، خودکار تایید می‌شود",
    "ur_PK": "دھوکا کرنے والے کارساز کے ذریعہ سے دور کرنے کے مقدار کی تصدیق کے باقی رہے گی، غیر تصدیق کی حکم آغاز ہونے کے بعد x دن کی تصدیق کی جائے گی"
  },
  tips4: {
    zh_CN: '款项未收到情况已反馈给代理，实际收款可能会延迟1~2小时到账，如已收到款项请确认收到。代理确认转账后的订单将在7天后自动确认。',
    en_US: 'The fact that the payment has not been received has been reported to the agent. The actual payment may be delayed by 1 to 2 hours. If the payment has been received, please confirm receipt. The order after the agent confirms the transfer will be automatically confirmed after 7 days.',
    ar_SA: 'لقد تم الإبلاغ للوكيل عن عدم استلام الدفعة. قد يتأخر الدفع الفعلي لمدة تتراوح من ساعة إلى ساعتين. إذا تم استلام الدفع، يرجى تأكيد الاستلام. سيتم تأكيد الطلب تلقائيًا بعد 7 أيام من تأكيد الوكيل للتحويل.',
    tr_TR: 'Ödemenin alınmadığı acenteye bildirildi. Gerçek ödeme 1-2 saat gecikebilir. Ödemeniz alındıysa lütfen makbuzu onaylayın. Siparişiniz, acentenin transferi onaylamasından itibaren 7 gün sonra otomatik olarak onaylanacaktır.',
    ru_RU: 'Платеж не был получен. Возможно, платеж может быть отложен на 1-2 часа. Пожалуйста, подтвердите получение платежа. Заказ будет подтвержден автоматически через 7 дней после того, как агент подтвердит перевод.',
    uz_UZ: "Pulni qaytarib olmagan buyurtmaga bildirildi. Haqiqiy pul o'tkazmasi 1-2 soatga kechiktirilishi mumkin. Pul o'tkazmasi qabul qilindi bo'lsa, quyidagi tugmani bosing va pulni qaytarib olmagan buyurtmaga bildirishingiz kerak. Agar pul o'tkazmasi tasdiqlanadi bo'lsa, buyurtma avtomatik ravishda tasdiqlanadi.",
    id_ID: 'Pembayaran tidak diterima telah diketahui oleh agen. Pembayaran yang sebenarnya mungkin ditunda 1-2 jam. Jika pembayaran sudah diterima, silakan konfirmasikan penerimaannya. Pesanan setelah agen menyetujui transfer akan secara otomatis dikonfirmasi dalam 7 hari.',
    pt_BR: 'O pagamento não foi recebido. O pagamento real pode ser atrasado de 1 a 2 horas. Se o pagamento tiver sido recebido, por favor confirme o recebimento. O pedido após o agente confirmar a transferência será confirmado automaticamente em 7 dias.',
    fa_IR: 'پرداخت نشده گفته شده است. پرداخت فعلی ۱-۲ ساعت تأخیر می کند. زمانی که پرداخت شده است، لطفا از طریق این بخش تأیید کنید. بعد از تایید مامور انتقال، سفارش ها به طور خودکار ۷ روز بعد از تایید آنها تأیید خواهد شد.',
    ur_PK: 'ادائیگی نہیں ملی ہے۔ حقیقی ادائیگی 1-2 گھنٹے کے ذریعہ دیر ہو سکتی ہے۔ اگر ادائیگی موصول ہوئی ہے تو براہ کرم اس کی تصدیق کریں۔ اگنٹر کی تصدیق کے بعد، 7 دنوں میں خود بخود تصدیق کی جائے گی.'
  },
  "汇款凭证": {
    "zh_CN": "汇款凭证",
    "en_US": "Remittance Voucher",
    "ar_SA": "الدليل التحويل",
    "tr_TR": "Havale Fişi",
    "ru_RU": "Документ о переводе средств",
    "uz_UZ": "Mablag'larni o'tkazish to'g'risidagi hujjat",
    "id_ID": "Swift",
    "pt_BR": "Swift",
    "fa_IR": " عده انتقال پول ",
    "ur_PK": "ٹرانسفر کا सबूत"
  },
  "联系Ta": {
    "zh_CN": "联系Ta",
    "en_US": "Contact Him/Her",
    "ar_SA": "اتصال",
    "tr_TR": "Onunla İletişime Geçin",
    "ru_RU": "Связаться с ним/ней",
    "uz_UZ": "U bilan bog'laning",
    "id_ID": "Kontak Ta",
    "pt_BR": "Contactar Ta",
    "fa_IR": "ارتباط با او",
    "ur_PK": "ٹا کا اپنا ملاقات"
  },
  "我收到了相应的工资": {
    "zh_CN": "我收到了相应的工资",
    "en_US": "I have received the corresponding salary",
    "ar_SA": "تم استلام راتب كامل",
    "tr_TR": "Ben buna karşılık gelen maaşı aldım",
    "ru_RU": "Я получил соответствующую зарплату",
    "uz_UZ": "Men tegishli maosh oldim",
    "id_ID": "Saya telah menerima gaji yang sama",
    "pt_BR": "Recebi o salário correspondente",
    "fa_IR": "من حقوق مناسب را دریافت کردم",
    "ur_PK": "مجھے اتنی پول ملی ہے"
  },
  "我没有收到或收到的工资更少": {
    "zh_CN": "我没有收到或收到的工资更少",
    "en_US": "I did not receive or received less salary",
    "ar_SA": "لم استلم اي راتب أو راتب ناقص",
    "tr_TR": "Maaş almadım veya daha az aldım",
    "ru_RU": "Я не получил или получил меньшую зарплату",
    "uz_UZ": "Men kam maosh olmadim yoki olmadim",
    "id_ID": "Saya tidak menerima atau menerima gaji yang kurang",
    "pt_BR": "não recebi nem recebi menos salário",
    "fa_IR": "من پاداش کمتری دریافت یا دریافت نکردم",
    "ur_PK": "مجھے کم اجرت نہ ملی"
  },
  "售后发起时间": {
    "zh_CN": "售后发起时间",
    "en_US": "Post-sale initiation time",
    "ar_SA": "وقت الشكوي ",
    "tr_TR": "Satış sonrası başlatma süresi",
    "ru_RU": "Время начала послепродажного обслуживания",
    "uz_UZ": "Sotishdan keyingi xizmatni boshlash vaqti",
    "id_ID": "Setelah awal penjualan",
    "pt_BR": "Tempo de início pós-venda",
    "fa_IR": "بعد از شروع فروش زمان",
    "ur_PK": "تبلیغات کے بعد"
  },
  "after_salesQ": {
    "zh_CN": "售后原因：我没有收到或收到的工资更少",
    "en_US": "Reason for initiating post-sale: I did not receive or received less salary.",
    "ar_SA": "سبب الشكوي: لم أستلم أو ارتب ناقص",
    "tr_TR": "Satış sonrası başlatma sebebim: Maaş almadım veya eksik aldım.",
    "ru_RU": "Причина инициирования послепродажного обслуживания: я не получал или получал меньшую зарплату.",
    "uz_UZ": "Sotishdan keyingi xizmatni boshlash sababi: men kamroq maosh olmadim yoki olmadim.",
    "id_ID": "Setelah menjual alasan: saya tidak menerima atau menerima gaji yang kurang",
    "pt_BR": "Razão pós-venda: Eu não recebi ou recebi menos salário",
    "fa_IR": "بعد از دلیل فروش: من کمترین حقوق را دریافت یا دریافت نکردم",
    "ur_PK": "تجارت کے بعد، مجھے کم اجرت نہ ملی"
  },
  "提款订单完成时间": {
    "zh_CN": "提款订单完成时间",
    "en_US": "Withdrawal order completed time",
    "ar_SA": "وقت إتمام  السحب",
    "tr_TR": "Para çekme emri tamamlanma süresi",
    "ru_RU": "Время выполнения заявки на вывод средств",
    "uz_UZ": "Pulni qaytarib olish uchun arizani bajarish vaqti",
    "id_ID": "Waktu penyelesaian perintah tarik",
    "pt_BR": "Tempo de conclusão da ordem de retirada",
    "fa_IR": "زمان تکمیل سفارش برداشت",
    "ur_PK": "کैش آউٹ کے آرڈر مکمل ہونے کا وقت"
  },
  "订单已被取消": {
    "zh_CN": "订单已被取消",
    "en_US": "Order cancelled",
    "ar_SA": "تم الغاء السحب",
    "tr_TR": "Sipariş iptal edildi",
    "ru_RU": "Заказ отменен",
    "uz_UZ": "Buyurtma bekor qilindi",
    "id_ID": "Perintah telah dibatalkan",
    "pt_BR": "A encomenda foi cancelada",
    "fa_IR": "سفارش کنسل شده است",
    "ur_PK": "سطح بند کیا گیا ہے"
  },
  "订单取消时间": {
    "zh_CN": "订单取消时间",
    "en_US": "Order cancelled time",
    "ar_SA": "وقت الغاء الطلب ",
    "tr_TR": "Sipariş iptal süresi",
    "ru_RU": "Время отмены заказа",
    "uz_UZ": "Buyurtmani bekor qilish vaqti",
    "id_ID": "Waktu batalan perintah",
    "pt_BR": "Tempo de cancelamento da encomenda",
    "fa_IR": "زمان لغو سفارش",
    "ur_PK": "اورڈر کانسل وقت"
  },
  "提交汇款凭证": {
    "zh_CN": "提交汇款凭证",
    "en_US": "Submit remittance voucher",
    "ar_SA": "تقديم الدليل التحويل ",
    "tr_TR": "Havale makbuzunu gönder",
    "ru_RU": "Предоставить документ о переводе средств",
    "uz_UZ": "Mablag'larni o'tkazish to'g'risidagi hujjatni taqdim eting",
    "id_ID": "Kirim surat pengiriman",
    "pt_BR": "Enviar voucher de remessa",
    "fa_IR": "فرستادن واچر انتقال",
    "ur_PK": "بھیج دینے واچر"
  },
  "拒接订单": {
    "zh_CN": "拒接订单",
    "en_US": "Reject Order",
    "ar_SA": "رفض طلب ",
    "tr_TR": "Siparişi Reddet",
    "ru_RU": "Отклонить заказ",
    "uz_UZ": "Buyurtmani rad etish",
    "id_ID": "menolak perintah",
    "pt_BR": "recusar uma ordem",
    "fa_IR": "سفارش را رد کنید",
    "ur_PK": "ایک حکم منع کریں"
  },
  popTips: {
    "zh_CN": "确定拒接该笔提现订单？",
    "en_US": "Are you sure you want to reject this withdrawal order?",
    "ar_SA": "تاكيد رفض هذا الطلب ",
    "tr_TR": "Bu para çekme emrini reddetmek istediğinizden emin misiniz?",
    "ru_RU": "Вы уверены, что хотите отклонить этот заказ о выводе средств?",
    "uz_UZ": "Ushbu pulni qaytarib olish buyurtmasini rad etishni xohlayotganingizga ishonchingiz komilmi?",
    "id_ID": "Apakah Anda yakin untuk menolak perintah penarikan ini?",
    "pt_BR": "Tem a certeza de rejeitar esta ordem de retirada?",
    "fa_IR": "آيا شما مطمئن هستيد كه اين دستور بازداشتن را تكذيب كنيد؟",
    "ur_PK": "کیا تم اس بات کو جھٹلاؤ گے؟"
  },
  "确定": {
    "zh_CN": "确定",
    "en_US": "Confirm",
    "ar_SA": "تاكيد ",
    "tr_TR": "Onaylamak",
    "ru_RU": "Подтверждать",
    "uz_UZ": "Tasdiqlash",
    "id_ID": "pasti",
    "pt_BR": "certo",
    "fa_IR": "مطمئنم",
    "ur_PK": "یقیناً"
  },
  "取消": {
    "zh_CN": "取消",
    "en_US": "Cancel",
    "ar_SA": "الغاء ",
    "tr_TR": "İptal",
    "ru_RU": "Отмена",
    "uz_UZ": "Bekor qilish",
    "id_ID": "batalkan",
    "pt_BR": "cancelar",
    "fa_IR": "& کنسل‌",
    "ur_PK": "بند کریں"
  },
  "提交成功": {
    "zh_CN": "提交成功",
    "en_US": "Successful",
    "ar_SA": "تقديم نجاحا ",
    "tr_TR": "Başarılı",
    "ru_RU": "Успешный",
    "uz_UZ": "Muvaffaqiyatli",
    "id_ID": "Dikirim dengan sukses",
    "pt_BR": "Enviado com sucesso",
    "fa_IR": "فرستادن موفقیت",
    "ur_PK": "موفقیت کے ساتھ بھیجا گیا"
  },
  "待处理提现": {
    "zh_CN": "待处理提现",
    "en_US": "Pending withdrawals",
    "ar_SA": "في انتظار ",
    "tr_TR": "Bekleyen çekimler",
    "ru_RU": "Ожидающие вывода средства",
    "uz_UZ": "Kutilayotgan pul mablag'lari",
    "id_ID": "Penundaan",
    "pt_BR": "Retirada pendente",
    "fa_IR": "بازداشتن باقی مانده",
    "ur_PK": "باقی رہنے والی بازگشت"
  },
  "查看详情": {
    "zh_CN": "查看详情",
    "en_US": "View Details",
    "ar_SA": "مراجعة التفاصيل ",
    "tr_TR": "Ayrıntıları Görüntüle",
    "ru_RU": "Просмотр подробной информации",
    "uz_UZ": "Tafsilotlarni ko'rish",
    "id_ID": "Lihat rincian",
    "pt_BR": "Ver detalhes",
    "fa_IR": "نمایش جزئیات",
    "ur_PK": "جزئیات دیکھو"
  },
  "订单已完成": {
    "zh_CN": "订单已完成",
    "en_US": "Order Completed",
    "ar_SA": "تم اكمل الطلب ",
    "tr_TR": "Sipariş Tamamlandı",
    "ru_RU": "Заказ выполнен",
    "uz_UZ": "Buyurtma bajarildi",
    "id_ID": "Perintah selesai",
    "pt_BR": "Ordem concluída",
    "fa_IR": "سفارش تموم شد",
    "ur_PK": "اوردر پورا ہوا"
  },
  "去确认订单": {
    "zh_CN": "去确认订单",
    "en_US": "Confirm Order",
    "ar_SA": "ذهاب لتأكيد الطلب",
    "tr_TR": "Siparişi Onayla",
    "ru_RU": "Подтвердите заказ",
    "uz_UZ": "Buyurtmani tasdiqlang",
    "id_ID": "Pergi konfirmasi perintah",
    "pt_BR": "Vai confirmar a ordem.",
    "fa_IR": "برو سفارش را تایید کنید",
    "ur_PK": "ادارہ کی تصدیق کرو"
  },
  "订单已取消": {
    "zh_CN": "订单已取消",
    "en_US": "The order has been cancelled.",
    "ar_SA": "تم إلغاء الطلب",
    "tr_TR": "Sipariş iptal edildi.",
    "ru_RU": "Заказ был отменен.",
    "uz_UZ": "Buyurtma bekor qilindi.",
    "id_ID": "Perintah dibatalkan",
    "pt_BR": "Pedido cancelado",
    "fa_IR": "سفارش کنسل شد",
    "ur_PK": "اوردر بند ہوا"
  },
  "该笔申诉订单已经被重新处理": {
    "zh_CN": "该笔申诉订单已经被重新处理",
    "en_US": "The complaint order has been reprocessed.",
    "ar_SA": "هذا الطلب المشكوي تم اعادة لمعالجة",
    "tr_TR": "Şikayet emri yeniden işleme alındı.",
    "ru_RU": "Заказ на подаче жалобы было рассмотрено повторно.",
    "uz_UZ": "Shikoyat buyurtmasi qayta ko'rib chiqildi.",
    "id_ID": "Perintah panggilan telah diproses ulang",
    "pt_BR": "O despacho de recurso foi reprocessado",
    "fa_IR": "دستور دعوت بازرسی شده است",
    "ur_PK": "آواز دینے کا حکم ناکام کیا گیا ہے"
  },
  "代理已转账，去确认": {
      "zh_CN": "代理已转账，去确认",
      "en_US": "The seller has transferred the funds, go to confirm.",
      "ar_SA": "لقد قام الوكيل بتحويل، انتقل للتأكيد",
      "tr_TR": "Satıcı parayı transfer etti, onaylamaya gidin.",
      "ru_RU": "Реселлер перевел средства, перейдите для подтверждения.",
      "uz_UZ": "Sotuvchi mablag'larni o'tkazdi, tasdiqlash uchun o'ting.",
      "id_ID": "Agen telah memindahkan dana, silakan konfirmasi",
      "pt_BR": "O agente transferiu os fundos, por favor confirme",
      "fa_IR": "مامور پول رو انتقال کرده لطفا تاييد کنيد",
      "ur_PK": "ایجنٹ نے فوندز کو ترجمہ کیا ہے، لطفا تصدیق کرو"
  },
  "该笔申诉订单已被重新处理": {
    "zh_CN": "该笔申诉订单已被重新处理",
    "en_US": "The complaint order has been reprocessed.",
    "ar_SA": "هذا الطلب المشكوي تم اعادة لمعالجة",
    "tr_TR": "Şikayet emri yeniden işleme alındı.",
    "ru_RU": "Заказ на подаче жалобы было рассмотрено повторно.",
    "uz_UZ": "Shikoyat buyurtmasi qayta ko'rib chiqildi.",
    "id_ID": "Perintah panggilan telah diproses ulang",
    "pt_BR": "O despacho de recurso foi reprocessado",
    "fa_IR": "دستور دعوت بازرسی شده است",
    "ur_PK": "آواز دینے کا حکم ناکام کیا گیا ہے"
  },
  "添加": {
    "zh_CN": "添加",
    "en_US": "Add",
    "ar_SA": "اضافة ",
    "tr_TR": "Eklemek",
    "ru_RU": "Добавь",
    "uz_UZ": "Qo'shish",
    "id_ID": "tambah",
    "pt_BR": "adicionar",
    "fa_IR": "افزودن",
    "ur_PK": "جمع کریں"
  },
  "有内容未填写": {
    "zh_CN": "有内容未填写",
    "en_US": "Something is missing to be filled.",
    "ar_SA": "هناك محتوى مفقود",
    "tr_TR": "Doldurulması gereken bir şey eksik.",
    "ru_RU": "Чего-то не хватает, чтобы это восполнить.",
    "uz_UZ": "Uni to'ldirish uchun biror narsa etishmayapti.",
    "id_ID": "Ada isi yang belum diisi",
    "pt_BR": "Há conteúdo que não foi preenchido",
    "fa_IR": "محتوای وجود دارد که",
    "ur_PK": "وہ راضی ہے جو بھر نہیں ہوئی"
  },
  钻石余额: {
    en_US: "Diamond Balance",
    ar_SA: "الرصيد الاشجاري",
    tr_TR: "Eşsiz Diyarbakır Bakiyesi",
    ru_RU: "Баланс Диамантов",
    uz_UZ: "Diaman bakiyesi",
    id_ID: "Saldo Diam",
    pt_BR: "Saldo de Diamante",
    fa_IR: "بازار دیمارتی",
    ur_PK: "دیمارتی کی روائش"
  },
  退出: {
    en_US: "Logout",
    ar_SA: "تسجيل الخروج",
    tr_TR: "Çıkış Yap",
    ru_RU: "Выйти",
    uz_UZ: "Chiqish",
    id_ID: "Keluar",
    pt_BR: "Sair",
    fa_IR: "خروج",
    ur_PK: "خروج"
  },
  请先添加提现账户: {
    en_US: "Please add a withdrawal account first.",
    ar_SA: "يرجى إضافة حساب السحب الأولا",
    tr_TR: "İlk olarak para çekme hesabı ekleyin.",
    ru_RU: "Пожалуйста, добавьте банковский счет для вывода.",
    uz_UZ: "Iltimos, withdrawal hisobini qo'shing.",
    id_ID: "Silakan tambahkan rekening pencairan terlebih dahulu.",
    pt_BR: "Por favor, adicione uma conta para saque primeiro.",
    fa_IR: "لطفا اولا حساب برداشت را اضافه کنید.",
    ur_PK: "اپنا اپنی بازگشت حساب کیا گیا ہے، لطفا اپنا بازگشت حساب کیا گیا ہے"
  },
  选择代理: {
    en_US: "Select Agent",
    ar_SA: "اختر الوكيل",
    tr_TR: "Ajanı Seçin",
    ru_RU: "Выберите агента",
    uz_UZ: "Agentni tanlang",
    id_ID: "Pilih Agen",
    pt_BR: "Selecione o agente",
    fa_IR: "انتخاب مامور",
    ur_PK: "ایجنٹ کا انتخاب کریں"
  },
  请选择代理: {
    en_US: 'Please select an agent',
    ar_SA: 'يرجى تحديد وكيل',
    tr_TR: 'Ajanı seçin',
    ru_RU: 'Пожалуйста, выберите агента',
    uz_UZ: 'Agentni tanlang',
    id_ID: 'Silakan pilih agen',
    pt_BR: 'Por favor, selecione um agente',
    fa_IR: 'لطفا مامور را انتخاب کنید',
    ur_PK: 'ایجنٹ کا انتخاب کریں'
  },
  请输入需要提款的金额: {
    en_US: 'Please enter the amount to withdraw.',
    ar_SA: 'يرجى إدخال المبلغ المطلوب سحبه',
    tr_TR: 'Çekmek istediğiniz miktarı girin.',
    ru_RU: 'Пожалуйста, введите сумму для вывода.',
    uz_UZ: 'Iltimos, withdrawal miqdori kiriting.',
    id_ID: 'Silakan masukkan jumlah pencairan.',
    pt_BR: 'Por favor, insira o valor para saque.',
    fa_IR: 'لطفا مقدار برداشت را وارد کنید.',
    ur_PK: 'براہ کرم وسائل بازگشت کی مقدار درج کریں'
  },
  请选择提款方式: {
    en_US: 'Please select a withdrawal method.',
    ar_SA: 'يرجى اختيار طريقة السحب',
    tr_TR: 'Çekme yöntemini seçin.',
    ru_RU: 'Пожалуйста, выберите способ вывода.',
    uz_UZ: "Iltimos, withdrawal uslugini tanlang.",
    id_ID: 'Silakan pilih metode pencairan.',
    pt_BR: 'Por favor, selecione um método de saque.',
    fa_IR: 'لطفا روش برداشت را انتخاب کنید.',
    ur_PK: 'براہ کرم وسائل بازگشت کیا گیا ہے، لطفا انتخاب کریں'
  },
  默认: {
    en_US: 'Default',
    ar_SA: 'الافتراضي',
    tr_TR: 'Varsayılan',
    ru_RU: 'По умолчанию',
    uz_UZ: 'Avvalgi',
    id_ID: 'Bawaan',
    pt_BR: 'Padrão',
    fa_IR: 'پیش‌فرض',
    ur_PK: 'پیش فرض'
  },
  删除: {
    en_US: 'Delete',
    ar_SA: 'حذف',
    tr_TR: 'Sil',
    ru_RU: 'Удалить',
    uz_UZ: 'Olib tashlash',
    id_ID: 'Hapus',
    pt_BR: 'Excluir',
    fa_IR: 'حذف',
    ur_PK: 'حذف کریں'
  },
  请输入: {
    en_US: 'Please enter',
    ar_SA: 'الرجاء إدخال',
    tr_TR: 'Lütfen girin',
    ru_RU: 'Пожалуйста, введите',
    uz_UZ: 'Iltimos kiriting',
    id_ID: 'Silakan masukkan',
    pt_BR: 'Por favor, insira',
    fa_IR: 'لطفا وارد کنید',
    ur_PK: 'براہ کرم وسائل کیا گیا ہے، لطفا وارد کریں'
  },
  取消订单: {
    en_US: 'Cancel Order',
    ar_SA: 'إلغاء الطلب',
    tr_TR: 'Siparişi İptal Et',
    ru_RU: 'Отменить заказ',
    uz_UZ: 'Buyurtmani bekor qilish',
    id_ID: 'Batalkan Perintah',
    pt_BR: 'Cancelar Ordem',
    fa_IR: 'سفارش را کنسل کنید',
    ur_PK: 'اوردر بند کریں'
  },
  请先上传凭证: {
    en_US: 'Please upload the voucher first.',
    ar_SA: 'يرجى تحميل الدليل أولاً',
    tr_TR: 'Lütfen önce makbuzu yükleyin.',
    ru_RU: 'Пожалуйста, сначала загрузите документ о переводе средств.',
    uz_UZ: "Iltimos, avval mablag'larni o'tkazish to'g'risidagi hujjatni yuklang.",
    id_ID: 'Silakan unggah bukti terlebih dahulu.',
    pt_BR: 'Por favor, faça o upload do comprovante primeiro.',
    fa_IR: 'لطفا اول واچر را آپلود کنید',
    ur_PK: 'براہ کرم پہلے واچر اپ لوڈ کریں'
  },
  提交: {
    en_US: 'Submit',
    ar_SA: 'تسجيل',
    tr_TR: 'Gönder',
    ru_RU: 'Отправить',
    uz_UZ: 'Jo\'natish',
    id_ID: 'Kirim',
    pt_BR: 'Enviar',
    fa_IR: 'ثبت',
    ur_PK: 'تسجيل کریں'
  },
  请选择小于3M的图片: {
    en_US: 'Please select an image less than 3M.',
    ar_SA: 'يرجى اختيار صورة أقل من 3 ميغابايت',
    tr_TR: "Lütfen 3MB'den küçük bir resim seçin.",
    ru_RU: 'Пожалуйста, выберите изображение меньше 3МБ.',
    uz_UZ: 'Iltimos, 3MB dan kichik rasm tanlang.',
    id_ID: 'Silakan pilih gambar kurang dari 3MB.',
    pt_BR: 'Por favor, selecione uma imagem menor que 3MB.',
    fa_IR: 'لطفا یک تصویر کمتر از 3 مگابایت را انتخاب کنید.',
    ur_PK: 'براہ کرم 3 مگابایت کمتر زیر ہوں ۔ تصویر کا انتخاب کریں'
  },
  拷贝成功: {
    en_US: 'Copied successfully',
    ar_SA: 'تم نسخ الصورة بنجاح',
    tr_TR: 'Başarıyla kopyalandı',
    ru_RU: 'Копирование успешно',
    uz_UZ: 'Muvaffaqiyatli nusxa olindi',
    id_ID: 'Berhasil disalin',
    pt_BR: 'Copiado com sucesso',
    fa_IR: 'کپی شد',
    ur_PK: 'کپی شد'
  },
  创建时间: {
    en_US: 'Creation Time',
    ar_SA: 'وقت الانشاء',
    tr_TR: 'Oluşturma Zamanı',
    ru_RU: 'Время создания',
    uz_UZ: 'Yaratilgan vaqt',
    id_ID: 'Waktu Pembuatan',
    pt_BR: 'Data de Criação',
    fa_IR: 'زمان ایجاد',
    ur_PK: 'تاریخ ایجاد'
  },
  原因: {
    en_US: 'Reason',
    ar_SA: 'السبب',
    tr_TR: 'Nedeni',
    ru_RU: 'Причина',
    uz_UZ: 'Sabab',
    id_ID: 'Alasan',
    pt_BR: 'Razão',
    fa_IR: 'سبب',
    ur_PK: 'سبب'
  },
  联系: {
    en_US: 'Contact',
    ar_SA: 'اتصال',
    tr_TR: 'İletişim',
    ru_RU: 'Контакт',
    uz_UZ: 'Aloqa',
    id_ID: 'Kontak',
    pt_BR: 'Contato',
    fa_IR: 'ارتباط',
    ur_PK: 'رابطہ'
  },
  上传于: {
    en_US: 'Uploaded on',
    ar_SA: 'تم الرفع في',
    tr_TR: 'Yüklenme Tarihi',
    ru_RU: 'Загружено',
    uz_UZ: 'Yuklangan vaqt',
    id_ID: 'Diunggah pada',
    pt_BR: 'Carregado em',
    fa_IR: 'بارگذاری شده در',
    ur_PK: 'تاریخ اپ لوڈ کردہ'
  },
  selectTips: {
    zh_CN: '最多选择 {{maxCount}} 张图片，你多选了 {{exceed}} 张',
    en_US: 'You can only select up to {{maxCount}} images, you selected {{exceed}} images.',
    ar_SA: 'يمكنك تحديد صورة واحدة أو أكثر ولكن لا تزيد عدد الصورة إلى {{maxCount}} ، وقد تم تحديد {{exceed}} صورة.',
    tr_TR: '{{maxCount}} adet resim seçebilirsiniz, siz {{exceed}} adet resim seçtiniz.',
    ru_RU: 'Вы можете выбрать не более {{maxCount}} изображений, вы выбрали {{exceed}} изображений.',
    uz_UZ: 'Sizda {{exceed}} ta rasm tanlangan, sizda {{maxCount}} ta rasm tanlangan.',
    id_ID: 'Anda hanya bisa memilih maksimal {{maxCount}} gambar, Anda memilih {{exceed}} gambar.',
    pt_BR: 'Você pode selecionar no máximo {{maxCount}} imagens, você selecionou {{exceed}} imagens.',
    fa_IR: 'شما فقط می توانید انتخاب کنید {{maxCount}} تصویر، انتخاب کرده اید {{exceed}} تصویر.',
    ur_PK: 'تصویر کا انتخاب کریں، ہم ہمیں {{maxCount}} تصویر کیا گیا ہے، ہم ہمیں {{exceed}} تصویر کیا گیا ہے'
  },
  预计到账: {
    en_US: 'Estimated arrival',
    ar_SA: 'توقع الوصول',
    tr_TR: 'Tahmini gelen',
    ru_RU: 'Предполагаемое прибытие',
    uz_UZ: 'Tasdiqlangan kelgan',
    id_ID: 'Estimasi tiba',
    pt_BR: 'Data de Chegada',
    fa_IR: 'تاریخ پیش‌بینی',
    ur_PK: 'تاریخ پیش بینی'
  },
  请保留至少一种提现方式: {
    en_US: 'Please keep at least one withdrawal method.',
    ar_SA: 'يرجى الاحتفاظ بطريقة سحب واحدة على الأقل.',
    tr_TR: 'Lütfen en az bir çekme yöntemi tutun.',
    ru_RU: 'Пожалуйста, оставьте хотя бы один способ вывода.',
    uz_UZ: 'Iltimos, kamida bitta pul olish usulini saqlang.',
    id_ID: 'Silakan tetapkan minimal satu metode pencairan.',
    pt_BR: 'Por favor, mantenha pelo menos uma forma de saque.',
    fa_IR: 'لطفا حداقل یک روش برداشت را باقبل داشته باشید.',
    ur_PK: 'براہ کرم وسائل بازگشت کیا گیا ہے، لطفا اپنا یکی از روش ها را حفظ کریں'
  },
  上传失败: {
    en_US: 'Upload failed',
    ar_SA: 'فشل الرفع',
    tr_TR: 'Yükleme başarısız',
    ru_RU: 'Загрузка не удалась',
    uz_UZ: 'Yuklab bo\'lmadi',
    id_ID: 'Gagal mengunggah',
    pt_BR: 'Falha no upload',
    fa_IR: 'آپلود نشد',
    ur_PK: 'اپ لوڈ ناکام'
  },
  提现订单: {
    en_US: 'Withdrawal Order',
    ar_SA: 'طلب سحب النقود ',
    tr_TR: 'Para çekme siparişi',
    ru_RU: 'Заказ на снятие наличных',
    uz_UZ: 'Pul chiqarish buyurtmasi',
    id_ID: 'Pesanan penarikan uang',
    pt_BR: 'Pedido de saque',
    fa_IR: 'سفارش سحب پول ',
    ur_PK: 'نقدی نکالنے کا آرڈر'
  },
  删除成功: {
    en_US: 'Deleted successfully',
    ar_SA: 'تم حذف الصورة بنجاح',
    tr_TR: 'Başarıyla silindi',
    ru_RU: 'Удаление успешно',
    uz_UZ: 'Olib tashlangan',
    id_ID: 'Berhasil dihapus',
    pt_BR: 'Excluído com sucesso',
    fa_IR: 'حذف شد',
    ur_PK: 'حذف کامیاب',
  },
  外管中心: {
    "zh_CN": "外管中心",
    "en_US": "Admin Center",
    "ar_SA": "مركز الإدارة",
    "tr_TR": "Yönetim Merkezi",
    "ru_RU": "Центр админа",
    "uz_UZ": "ADMIN markazi",
    "pt_BR": "Centro Admin",
    "fa_IR": " مرکز مدیریت",
    "ur_PK": "انتظام کا مرکز",
    id_ID: "Pusat Admin"
  },
  BD中心: {
    "zh_CN": "BD中心",
    "en_US": "BD Center ",
    "ar_SA": "مركز التطوير الأعمال",
    "tr_TR": "İş Geliştirme Merkezi",
    "ru_RU": "Центр БД",
    "uz_UZ": "BD markazi",
    "pt_BR": "Centro BD",
    "fa_IR": " مرکز توسعه کسب و کار",
    "ur_PK": "ایجنسی بیزنس ترقی کا مرکز",
    id_ID: "Pusat BD"
  },
  创建公会: {
    "zh_CN": "创建公会",
    "en_US": "Create an Agency",
    "ar_SA": "تفعيل الوكالة ",
    "tr_TR": "Yönetim Merkezi",
    "ru_RU": "Создать агентство",
    "uz_UZ": "Agentlik yarating",
    "pt_BR": "Criar uma Agência",
    "fa_IR": "ایجاد انجمن",
    "ur_PK": "گِلڈ بنائیں",
    id_ID: "Buat Agensi"
  },
  外管或BD的ID: {
    "zh_CN": "外管或BD的ID",
    "en_US": "ID of Admin or BD",
    "ar_SA": "/",
    "tr_TR": "Bir Ajans Oluşturun",
    "ru_RU": "ID АДМИНА или БД",
    "uz_UZ": "Administrator yoki BD ID",
    "pt_BR": "ID do Administrador ou BD",
    "fa_IR": "شناسه مدیر خارجی یا BD",
    "ur_PK": "بیرونی مینیجر یا BD کا آئی ڈی",
    id_ID: 'ID Admin atau BD',
  },
  邀请者: {
    "zh_CN": "邀请者",
    "en_US": "Inviter",
    "ar_SA": "داعي ",
    "tr_TR": "Davet eden",
    "ru_RU": "Приглашающий",
    "uz_UZ": "Taklif etuvchi",
    "pt_BR": "Convidador",
    "fa_IR": "دعوت‌کننده",
    "ur_PK": "مدعو کرنے والا",
    id_ID: 'Pengundang'
  },
  公会名称: {
    "zh_CN": "公会名称",
    "en_US": "Agency Name",
    "ar_SA": "اسم الوكالة ",
    "tr_TR": "Ajans İsmi ",
    "ru_RU": "Название агентства",
    "uz_UZ": "Agentlik nomi",
    "pt_BR": "Nome da Agência",
    "fa_IR": "نام انجمن",
    "ur_PK": "گِلڈ کا نام",
    id_ID: 'Nama Agensi'
  },
  公会封面: {
    "zh_CN": "公会封面",
    "en_US": "Cover of the Agency",
    "ar_SA": "غلافة الوكالة ",
    "tr_TR": "Ajansın Kapağı",
    "ru_RU": "Обложка агентства",
    "uz_UZ": "Agentlik qoplamasi",
    "pt_BR": "Sobrenome da Agência",
    "fa_IR": "تصویر روی جلد انجمن",
    "ur_PK": "گِلڈ کا کور",
    id_ID: 'Sampul Agensi'
  },
  地区: {
    "zh_CN": "地区",
    "en_US": "Country",
    "ar_SA": "دولة ",
    "tr_TR": "Ülke",
    "ru_RU": "Страна",
    "uz_UZ": "Mamlakat",
    "pt_BR": "País",
    "fa_IR": "منطقه",
    "ur_PK": "علاقہ",
    id_ID: 'Negara'
  },
  联系电话: {
    "zh_CN": "联系电话",
    "en_US": "Phone Mumber",
    "ar_SA": "رقم الجوال ",
    "tr_TR": "Telefon Numarası ",
    "ru_RU": "Номер телефона",
    "uz_UZ": "Telefon raqami",
    "pt_BR": "Número de Telefone",
    "fa_IR": "شماره تماس",
    "ur_PK": "رابطہ نمبر",
    id_ID: 'No. Telepon'
  },
  联系地址: {
    "zh_CN": "联系地址",
    "en_US": "Contact Address",
    "ar_SA": "عنوان ",
    "tr_TR": "İletişim Adresi",
    "ru_RU": "Контактный адрес",
    "uz_UZ": "Aloqa manzili",
    "pt_BR": "Endereço de Contato",
    "fa_IR": "آدرس تماس",
    "ur_PK": "رابطہ پتہ",
    id_ID: 'Alamat Kontak'
  },
  真实姓名: {
    "zh_CN": "真实姓名",
    "en_US": "Real Name",
    "ar_SA": "اسم حقيقي ",
    "tr_TR": "Gerçek İsim ",
    "ru_RU": "Настоящее имя",
    "uz_UZ": "Haqiqiy ism",
    "pt_BR": "Nome Real",
    "fa_IR": "نام واقعی",
    "ur_PK": "اصل نام",
    id_ID: 'Nama Asli'
  },
  选择地区: {
    "zh_CN": "选择地区",
    "en_US": "Select Country",
    "ar_SA": "اختار دولة ",
    "tr_TR": "Ülke Seçin",
    "ru_RU": "Выберите страну",
    "uz_UZ": "Mamlakatni tanlang",
    "pt_BR": "Selecionar País",
    "fa_IR": "انتخاب منطقه",
    "ur_PK": "علاقہ منتخب کریں",
    id_ID: 'Pilih Negara',
  },
  请再次确定您的上级管理为: {
    "zh_CN": "请再次确定您的上级管理为",
    "en_US": "Please make sure again that your admin is",
    "ar_SA": "الرجاء تاكيد ادمن بك  ",
    "tr_TR": "Lütfen yöneticinizin tekrar olduğundan emin olun",
    "ru_RU": "Пожалуйста, убедитесь еще раз, что ваш админ",
    "uz_UZ": "Iltimos, administratoringizni ikki marta tekshiring",
    "pt_BR": "Certifique-se novamente de que seu administrador esteja",
    "fa_IR": "لطفاً بار دیگر سرپرست خود را تأیید کنید",
    "ur_PK": "براہ کرم دوبارہ اپنے اعلیٰ مینیجر کی تصدیق کریں",
    id_ID: 'Silakan cek kembali bahwa Anda adalah admin',
  },
  "确定，继续提交": {
    "zh_CN": "确定，继续提交",
    "en_US": "Confirm to continue submitting",
    "ar_SA": "تاكيد ، تقديم مستمرا ",
    "tr_TR": "Göndermeye devam etmek için onaylayın",
    "ru_RU": "Подтвердите, чтобы продолжить отправку",
    "uz_UZ": "Yuborishni davom ettirish uchun tasdiqlang.",
    "pt_BR": "Confirme para continuar enviando",
    "fa_IR": "تأیید، ادامه ارسال",
    "ur_PK": "تصدیق کریں، جمع کرائیں",
    id_ID: 'Konfirmasi, lanjutkan mengirim',
  },
  公会列表: {
    "zh_CN": "公会列表",
    "en_US": "List of Agencies",
    "ar_SA": "قائمة الوكلات ",
    "tr_TR": "Ajansların Listesi",
    "ru_RU": "Список агентств",
    "uz_UZ": "Agentliklar ro'yxati",
    "pt_BR": "Lista de Agências",
    "fa_IR": "فهرست انجمن‌ها",
    "ur_PK": "گِلڈ کی فہرست",
    id_ID: 'Daftar Agensi'
  },
  "下级BD": {
    "zh_CN": "下级BD",
    "en_US": "BD",
    "ar_SA": "BD",
    "tr_TR": "BD ",
    "ru_RU": "БД",
    "uz_UZ": "BD",
    "pt_BR": "BD",
    "fa_IR": "BD زیردست",
    "ur_PK": "ماتحت BD",
    id_ID: 'BD',
  },
  公会申请: {
    "zh_CN": "公会申请",
    "en_US": "Agency Application",
    "ar_SA": "طلب الوكالة ",
    "tr_TR": "Ajans Başvurusu",
    "ru_RU": "Заявка на агентство",
    "uz_UZ": "Agentlik uchun ariza",
    "pt_BR": "Inscrição da Agência",
    "fa_IR": "درخواست انجمن",
    "ur_PK": "گِلڈ کی درخواست",
    id_ID: 'Permohonan Agensi',
  },
  暂未关联公会: {
    "zh_CN": "暂未关联公会",
    "en_US": "Not yet associated with an agency",
    "ar_SA": "لا توجد وكالة  مرتبطة حاليا",
    "tr_TR": "Henüz bir ajansla ilişkilendirilmedi oy",
    "ru_RU": "Пока не связан с агентством",
    "uz_UZ": "Hozircha agentlikka aloqador emas",
    "pt_BR": "Ainda não associado a uma agência",
    "fa_IR": "هنوز به انجمنی متصل نشده‌اید",
    "ur_PK": "ابھی تک کسی گِلڈ سے منسلک نہیں ہیں",
    id_ID: 'Belum terkait dengan agensi'
  },
  上级外管: {
    "zh_CN": "上级外管",
    "en_US": "Admin",
    "ar_SA": "ادمن ",
    "tr_TR": "Yönetici.",
    "ru_RU": "АДМИН",
    "uz_UZ": "ADMIN",
    "pt_BR": "Administrador",
    "fa_IR": "مدیر خارجی بالادست",
    "ur_PK": "اعلیٰ بیرونی مینیجر",
    id_ID: 'Admin'
  },
  "将主播移除公会的操作只能在每个月的2号至4号，或者17号至19号。": {
    "zh_CN": "将主播移除公会的操作只能在每个月的2号至4号，或者17号至19号。",
    "en_US": "The removal of the anchor from the guild can only be done from the 2nd to the 4th or from the 17th to the 19th of each month.",
    "ar_SA": "/",
    "tr_TR": "/",
    "ru_RU": "Удаление ведущего из агентства может быть произведено только со 2-го по 4-е или с 17-го по 19-е число каждого месяца.",
    "uz_UZ": "Taqdimotchini agentlikdan olib tashlash faqat har oyning 2-dan 4-kuniga yoki 17-dan 19-kuniga qadar amalga oshirilishi mumkin.",
    "pt_BR": "A retirada da âncora da guilda só poderá ser feita do dia 2 ao dia 4 ou do dia 17 ao dia 19 de cada mês.",
    "fa_IR": "حذف میزبان از انجمن فقط در روزهای ۲ تا ۴ یا ۱۷ تا ۱۹ هر ماه امکان‌پذیر است.",
    "ur_PK": "میزبان کو گِلڈ سے ہٹانے کا عمل صرف ہر ماہ کی 2 سے 4 اور 17 سے 19 تاریخ کے درمیان ممکن ہے۔",
    id_ID: 'Hapus penyiwar dari agensi hanya dapat dilakukan pada hari ke-2 hingga ke-4 atau hari ke-17 hingga ke-19 setiap bulan.'
  },
  "公会已创建": {
    "zh_CN": "公会已创建",
    "en_US": "Agency has been created.",
    "ar_SA": "تم تفعيل ",
    "tr_TR": "Ajans oluşturuldu.",
    "ru_RU": "Агентство создано.",
    "uz_UZ": "Agentlik tuzildi.",
    "pt_BR": "A agência foi criada.",
    "fa_IR": "انجمن ایجاد شد",
    "ur_PK": "گِلڈ بن چکی ہے",
    id_ID: 'Agensi telah dibuat.'
  },
  "请输入正确的上级外管或BD的ID": {
    "zh_CN": "请输入正确的上级外管或BD的ID",
    "en_US": "Please enter the correct ID of Admin or BD.",
    "ar_SA": "",
    "tr_TR": "Doğru üst düzey veya BD kimliğini girin",
    "ru_RU": "Введите правильный айди ващего АДМИНА или БД",
    "uz_UZ": "Admin yoki BD ning toʻgʻri identifikatorini kiriting.",
    "pt_BR": "Insira o ID correto do Administrador ou Administrador.",
    "fa_IR": "لطفاً شناسه صحیح مدیر خارجی یا BD را وارد کنید",
    "ur_PK": "براہ کرم درست اعلیٰ بیرونی مینیجر یا BD کا آئی ڈی درج کریں",
    id_ID: 'Silakan masukkan ID Admin atau BD yang benar.'
  },
  '是否通过{{id}}申请{{name}}创建？': {
    "zh_CN": '是否通过{{id}}申请{{name}}创建？',
    "en_US": 'Is {{name}} applying to create {{id}}?',
    "ar_SA": 'هل {{name}} يطلب التوسع في {{id}}؟',
    "tr_TR": '{{name}} {{id}} oluşturmak için onaylanıyor mu?',
    "ru_RU": 'Заявка на создание {{id}} называется {{name}}?',
    "uz_UZ": '{{name}} agentlik yaratishga {{id}} tasdiqlanmoqchimisiz?',
    "pt_BR": 'O {{name}} está aplicando para criar {{id}}?',
    "fa_IR": 'آیا {{name}} اینکه {{id}} را ایجاد کند؟',
    "ur_PK": 'کیا {{name}} میں {{id}} کو ایجاد کرنے کی اجازت دیتا ہے؟',
    id_ID: 'Apakah {{name}} mengajukan membuat {{id}}?'
  },
  '是否拒绝{{id}}申请{{name}}创建？': {
    zh_CN: '是否拒绝{{id}}申请{{name}}创建？',
    en_US: 'Is {{name}} rejecting the application to create {{id}}?',
    ar_SA: 'هل {{name}} رفض التوسع في {{id}}؟',
    tr_TR: '{{name}} {{id}} oluşturmak için isteği reddetiyor mu?',
    ru_RU: 'Заявка на создание {{id}} называется {{name}}?',
    uz_UZ: '{{name}} agentlik yaratishga {{id}} qayta qabul qilishga ruxsat qilmoqchimisiz?',
    pt_BR: 'O {{name}} está rejeitando a solicitação de criação de {{id}}?',
    fa_IR: 'آیا {{name}} اینکه {{id}} را ایجاد نکند؟',
    ur_PK: 'کیا {{name}} میں {{id}} کو ایجاد کرنے کی اجازت دیتا ہے؟',
    id_ID: 'Apakah {{name}} menolak permintaan membuat {{id}}?'
  },
  '拒绝申请失败，请稍后重试~': {
    zh_CN: '拒绝申请失败，请稍后重试~',
    en_US: 'Failed to reject the application, please try again later~',
    ar_SA: 'فشل في رفض التوسع، يرجى المحاولة مرة اخرى~',
    tr_TR: 'Başvuru reddetme başarısız oldu, lütfen daha sonra tekrar deneyin~',
    ru_RU: 'Не удалось отклонить заявку, пожалуйста, попробуйте позже~',
    uz_UZ: 'Qayta qabul qilish ariza qilishda xatolik yuz berdi, iltimos, biror qadamda urinib koʻring~',
    pt_BR: 'Falha ao recusar a solicitação, por favor tente novamente em breve~',
    fa_IR: 'رفع درخواست انجمن ناموفق بود، لطفا دوباره امتحان کنید~',
    ur_PK: 'ایجاد کرنے کی اجازت دیتا ہے، لطفا دوبارہ اپنے کمپیوٹر کے لئے دوبارہ کامیاب کریں~',
    id_ID: 'Gagal menolak permintaan, silakan coba lagi nanti~'
  },
  '操作ID: {{id}}': {
    en_US: 'Executor ID: {{id}}',
    ar_SA: 'ID العملية: {{id}}',
    tr_TR: 'Onaylayan ID: {{id}}',
    pt_BR: 'ID do Executor: {{id}}',
    id_ID: 'ID Pelaksana: {{id}}',
    ru_RU: 'ID исполнителя: {{id}}',
    uz_UZ: 'ID ishlab chiqaruvchi: {{id}}',
    fa_IR: 'ID اجراگر: {{id}}',
    ur_PK: 'ID اپنی کامیاب: {{id}}'
  },
  外管ID: {
    zh_CN: '外管ID',
    en_US: 'Admin ID',
    ar_SA: 'المعرف الخارجي',
    tr_TR: 'Yönetici Kimliği',
    ru_RU: 'АДМИН ID',
    uz_UZ: 'ADMIN ID',
    pt_BR: 'ID do Administrador',
    fa_IR: 'مدیر خارجی ID',
    ur_PK: 'اعلیٰ بیرونی مینیجر کی آئی',
    id_ID: 'ID Admin'
  },
  真实名字: {
    zh_CN: '真实名字',
    en_US: 'Real Name',
    ar_SA: 'الاسم الوارد',
    tr_TR: 'Gerçek Adı',
    ru_RU: 'Имя',
    uz_UZ: 'Ism',
    pt_BR: 'Nome Real',
    fa_IR: 'نام فعلی',
    ur_PK: 'آف کا نام',
    id_ID: 'Nama Asli'
  },
  移除成功: {
    zh_CN: '移除成功',
    en_US: 'Removal successful',
    ar_SA: 'تم إزالة الوكالة',
    tr_TR: 'Ajans kaldırıldı',
    ru_RU: 'Агентство удалено',
    uz_UZ: 'Agentlik olib tashildi',
    pt_BR: 'A agência foi removida',
    fa_IR: 'انجمن حذف شد',
    ur_PK: 'گِلڈ کا منسلک ہوئی',
    id_ID: 'Agensi berhasil dihapus'
  },

};


export default locales;
